// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-10-29T20:20:40.205Z
// Property: Bolero (ID: 6767906449167137)
// Collections: 46 amenities, 23 floorplans (live), 17 photos, 33 POIs, 7 reviews, 4 virtual tours, 6 office hours, 1 special offers (live), 7 faqs
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5726763346821120",
  "multihub_property_id": "6767906449167137",
  "property_external_id": "1125085",
  "property_zillow_url": "https://www.zillow.com/apartments/phoenix-az/bolero/5XhyH8/",
  "property_apartments_url": "https://www.apartments.com/bolero-phoenix-az/p1nw8qv/",
  "property_google_business_url": "https://www.google.com/maps/place/Bolero/data=!4m2!3m1!1s0x0:0xbb85a463d86ac99f?sa=X&ved=2ahUKEwjE4LOB0oOTAxXmSTABHZ0qNAcQ_BJ6BAgYEAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": "47594847664",
  "property_crm_software": "Yardi RentCafe",
  "property_pm_software": "Yardi",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "bolero",
  "property_name": "Bolero",
  "property_website_url": "https://www.boleroapartments.com",
  "property_domain": "https://www.boleroapartments.com",
  "property_address": "7725 W McDowell Rd",
  "property_full_address": "7725 W McDowell Rd, Phoenix, AZ, 85035",
  "property_address_1": "7725 W McDowell Rd",
  "property_address_2": null,
  "property_address_city": "Phoenix",
  "property_address_state": "AZ",
  "property_address_zip_full": null,
  "property_address_zip": "85035",
  "property_address_country": "US",
  "property_address_county": "Maricopa County",
  "property_neighborhood_address": "Maryvale Village",
  "property_address_latitude": "33.4651",
  "property_address_longitude": "-112.2256",
  "property_email": "bolero@weidner.com",
  "property_phone": "9282186896",
  "property_call_tracking_phone": "623-432-5807",
  "property_company_name": "Weidner Apartment Homes",
  "property_company_url": "https://www.weidner.com/",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "At Bolero in vibrant Phoenix, AZ, choose from an array of thoughtfully designed floor plans, from cozy one bedrooms to spacious three bedrooms. Enjoy resort-style amenities like enchanting pools, a fitness center, and a bike-friendly environment. Embrace community living with social activities and conveniences at your fingertips—your new home awaits!",
  "property_long_description": "**Welcome to Bolero: Your Ideal Apartment Community in Phoenix, AZ**\n\nDiscover your perfect sanctuary at Bolero, where comfort meets convenience in the heart of Phoenix. Our thoughtfully designed one, two, and three-bedroom apartments cater to all lifestyles, offering spacious floor plans that maximize your living experience. With an exceptional array of amenities, Bolero elevates your day-to-day with features like a state-of-the-art fitness center, inviting swimming pools, and relaxing spa. \n\nEnjoy peace of mind with our 24-hour security and emergency maintenance services, ensuring you feel safe and secure in your new home. Socialize with neighbors at our planned community activities or unwind in the charming outdoor picnic areas and cabanas. Pet lovers will appreciate our dog and cat-friendly policy, while cyclists can take advantage of our dedicated bicycle storage. \n\nLocated near ASU and on public transportation routes, Bolero is perfect for anyone seeking a vibrant lifestyle. Our energy-efficient apartments come equipped with modern stainless steel appliances, granite countertops, and options for hardwood and tile flooring. Residents can enjoy the convenience of online rent payments, maintenance requests, and free high-speed Wi-Fi throughout the community.\n\nWhether you’re seeking tranquility or an active lifestyle, Bolero offers it all with additional features like cozy walk-in closets, in-unit washers and dryers, and smoke-free living. \n\nDon’t miss your chance to join this thriving community—find your new home today! Browse our availability or schedule a tour to experience Bolero firsthand. We can’t wait to welcome you home!",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167137/019d26a6-d12d-7523-99b7-757e4d9f4abc.webp",
  "property_featured_image_media": {
    "alt_text": null,
    "public_id": "019d26a6-d12d-7523-99b7-757e4d9f4abc",
    "storage_key": "property/6767906449167137/019d26a6-d12d-7523-99b7-757e4d9f4abc.webp",
    "width": 1920,
    "height": 702
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "579",
  "property_year_built": "2008",
  "property_year_renovated": null,
  "property_walk_score": "48",
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "90.50086355785838",
  "property_admin_fee": null,
  "property_application_fee": "60",
  "property_fees_deposit_info": "300-400",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "200",
  "property_pet_deposit": "200",
  "property_monthly_pet_rent": "25",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "50",
  "property_pet_restrictions": "Cats and dogs allowed (max 2 pets per unit), each up to 50 lbs.",
  "property_pet_policy_description": "Cats and dogs allowed (max 2 pets per unit), each up to 50 lbs. Non‑refundable pet fee: $200 per pet. Refundable pet deposit: $200 per pet. Monthly pet rent: $25 per pet.",
  "property_petpolicy_info": null,
  "property_online_leasing_url": "https://boleroapartments.securecafe.com/onlineleasing/bolero-0/floorplans.aspx",
  "property_resident_portal_url": "https://boleroapartments.securecafenet.com/residentservices/bolero-0/userlogin",
  "property_apply_now_url": "https://boleroapartments.securecafe.com/onlineleasing/bolero-0/guestlogin.aspx",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167137/019d26a5-d8d8-7264-ac81-045b2621b123.webp",
  "property_primary_logo_media": {
    "alt_text": null,
    "public_id": "019d26a5-d8d8-7264-ac81-045b2621b123",
    "storage_key": "property/6767906449167137/019d26a5-d8d8-7264-ac81-045b2621b123.webp",
    "width": 490,
    "height": 150
  },
  "property_secondary_logo": null,
  "property_secondary_logo_media": null,
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167137/019d270e-d36c-744e-92a0-a933beb5d812.webp",
  "property_mono_white_logo_media": {
    "alt_text": "Bolero Apartment Homes logo",
    "public_id": "019d270e-d36c-744e-92a0-a933beb5d812",
    "storage_key": "property/6767906449167137/019d270e-d36c-744e-92a0-a933beb5d812.webp",
    "width": 490,
    "height": 150
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167137/019d270e-da19-7479-8f4d-3e436e82eebb.webp",
  "property_mono_black_logo_media": {
    "alt_text": "Bolero Apartment Homes logo",
    "public_id": "019d270e-da19-7479-8f4d-3e436e82eebb",
    "storage_key": "property/6767906449167137/019d270e-da19-7479-8f4d-3e436e82eebb.webp",
    "width": 490,
    "height": 150
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d0198-4291-7593-82c0-efd4c864db24.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d0198-5322-7081-947b-e809ba802b6c.webp",
  "property_company_logo_media": {
    "alt_text": "Weidner Apartment Homes logo",
    "public_id": "019d0198-5322-7081-947b-e809ba802b6c",
    "storage_key": "company/5726763346821120/019d0198-5322-7081-947b-e809ba802b6c.webp",
    "width": 1342,
    "height": 402
  },
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d270e-bdc5-779e-a400-a391326cc801.webp",
  "property_company_mono_black_logo_media": {
    "alt_text": "Weidner Apartment Homes logo",
    "public_id": "019d270e-bdc5-779e-a400-a391326cc801",
    "storage_key": "company/5726763346821120/019d270e-bdc5-779e-a400-a391326cc801.webp",
    "width": 640,
    "height": 192
  },
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d270e-c548-748f-97de-b042810ed358.webp",
  "property_company_mono_white_logo_media": {
    "alt_text": "Weidner Apartment Homes logo",
    "public_id": "019d270e-c548-748f-97de-b042810ed358",
    "storage_key": "company/5726763346821120/019d270e-c548-748f-97de-b042810ed358.webp",
    "width": 640,
    "height": 192
  },
  "property_primary_color": "#d1d2d4",
  "property_secondary_color": "#5b5e5f",
  "property_font_color": null,
  "property_color_4": null,
  "property_color_3": null,
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "studio - 3",
  "property_bedrooms_min": "studio",
  "property_bedrooms_max": "3",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": " - 1060",
  "property_sqft_min": "483",
  "property_sqft_max": "1060",
  "property_price_range": "947 - 2365",
  "property_price_min": "947",
  "property_price_max": "2365",
  "property_available_units": 75,
  "property_facebook_url": "https://www.facebook.com/BoleroApartmentHomes/",
  "property_instagram_url": "https://www.instagram.com/boleroapthomes/",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJmYZ8jnAVK4cRn8lq2GOkhbs",
  "property_youtube_url": "https://www.youtube.com/@WeidnerApartmentHomes",
  "property_yelp_url": null,
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Bolero",
  "property_home_romance_title": "Embrace Life in Your Ideal Apartment Community Today",
  "property_home_amenities_blurb": "At Bolero in Phoenix, AZ, luxury meets comfort. Choose from one, two, or three-bedroom floor plans, each designed with you in mind. Enjoy delightful amenities like a serene courtyard, state-of-the-art fitness center, and enchanting swimming pools. Your ideal lifestyle awaits—tailored for relaxation and vibrant community living.",
  "property_home_floorplans_blurb": "Welcome to Bolero in vibrant Phoenix, AZ, where modern living meets stylish design. Each of our thoughtfully crafted floor plans offers the perfect blend of comfort and elegance. Browse our available apartment homes today and discover the perfect fit for your lifestyle amid the stunning Arizona landscape.",
  "property_home_gallery_blurb": "At Bolero in Phoenix, AZ, vibrant living meets modern convenience. Choose from spacious one to three-bedroom floor plans, all equipped with upscale amenities like enchanting swimming pools, a fully appointed fitness center, and a welcoming picnic area. Picture yourself in a smoke-free, pet-friendly haven, where every detail enhances your lifestyle!",
  "property_home_neighborhood_blurb": "Welcome to Bolero, your ideal sanctuary in Phoenix, AZ! Embrace a vibrant living experience surrounded by excellent educational institutions. With floor plans ranging from cozy one-bedroom retreats to spacious three-bedroom homes, you’ll find the perfect fit. See what’s around our community and connect with nearby schools and local favorites!",
  "property_home_reviews_blurb": "At Bolero in Phoenix, AZ, residents rave about our vibrant community, noting it's \"the perfect blend of comfort and style.\" With lush landscapes and modern amenities, life here feels like a getaway. Come see what our residents have to say about living at our community and feel the Bolero experience!",
  "property_neighborhood_blurb": "At Bolero in Phoenix, AZ, our vibrant community is surrounded by renowned educational institutions, including Fowler Elementary and Sierra Linda High School. Families will appreciate the proximity to Sunrise Pre-School and Mission Christian School. Embrace a neighborhood that supports growth and learning; delve into nearby points of interest today!",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "At Bolero in vibrant Phoenix, AZ, your ideal lifestyle awaits. Enjoy spacious one, two, and three-bedroom floor plans with high-end finishes. Embrace a wealth of amenities including a stunning pool, fitness center, and community events, all designed to elevate your living experience. Life at Bolero is simply unmatched!",
  "property_applynow_blurb": "At Bolero in Phoenix, your perfect new home awaits! Choose from one, two, or three-bedroom floor plans, all complemented by resort-style amenities. Enjoy 24-hour access to fitness facilities, enchanting swimming pools, and a vibrant courtyard. With online leasing and a pet-friendly environment, hassle-free living starts here! ",
  "property_contactus_blurb": "At Bolero in Phoenix, AZ, we offer thoughtfully designed floor plans, from cozy one-bedroom retreats to spacious three-bedroom homes. Each layout is crafted for comfort and style. Have questions? Our friendly leasing team is here to assist you—reach out to us today! Your ideal apartment awaits.",
  "property_faqs_blurb": "At Bolero in vibrant Phoenix, AZ, we offer a range of thoughtfully designed floor plans, from cozy one-bedrooms to spacious three-bedrooms, perfect for every lifestyle. Curious about our community? Dive into our FAQs page for insights and answers to your questions. Your ideal home awaits!",
  "property_floorplans_blurb": "At Bolero in Phoenix, AZ, our thoughtfully designed floor plans cater to every lifestyle. From cozy one-bedroom retreats to spacious three-bedroom residences, each layout harmonizes comfort and style. Browse our available apartment homes and uncover the perfect floor plan that complements your unique lifestyle today!",
  "property_gallery_blurb": "At Bolero in Phoenix, AZ, vibrant living meets modern comfort. Choose from one, two, or three-bedroom floor plans featuring stainless steel appliances and granite countertops. With amenities like a stunning pool, fitness center, and social activities, your dream apartment life awaits. Picture yourself living here!",
  "property_interactivemap_blurb": "At Bolero in Phoenix, AZ, choose from spacious one, two, or three-bedroom floor plans designed for comfort and style. Enjoy unparalleled amenities like enchanting pools, a fitness center, and social activities—all in a welcoming, smoke-free community. Use our interactive map to find your perfect home today!",
  "property_pets_blurb": "Welcome to Bolero in vibrant Phoenix, AZ, where your furry friends can thrive! Enjoy spacious living with a pet-friendly policy, welcoming two pets up to 50 lbs. Revel in endless outdoor adventures while creating memories in your stylish new home. Embrace the ultimate lifestyle at Bolero—you and your pets deserve it!",
  "property_referafriend_blurb": "At Bolero in vibrant Phoenix, AZ, your dream home awaits! Choose from spacious one, two, or three-bedroom floor plans that blend comfort with style. Great friends make great neighbors—refer a friend today and experience the joy of community living together! Your perfect apartment lifestyle is just a referral away!",
  "property_residentaccess_blurb": "Welcome to Bolero in vibrant Phoenix, AZ, where your ideal living space awaits! From cozy one-bedroom retreats to spacious three-bedroom homes, we offer diverse floor plans tailored just for you. Access your resident portal now to effortlessly pay rent, schedule maintenance, and stay connected with your community!",
  "property_reviews_blurb": "At Bolero in Phoenix, AZ, residents rave about their experience, noting how \"the vibrant community and amenities make every day feel special.\" There's no better way to understand the Bolero lifestyle than through the voices of our satisfied residents. See what our residents have to say about living at our community!",
  "property_created_at": "1771529670447",
  "property_scheduletour_blurb": "At Bolero in Phoenix, AZ, find your perfect fit with our diverse floor plans—choose from one, two, or three-bedroom apartments tailored to your lifestyle. Curious about life here? Schedule a tour today and see why our residents love calling Bolero home!",
  "property_thankyou_blurb": "Thank you for your interest in Bolero, where vibrant living meets serene comfort in the heart of Phoenix, AZ. From cozy one-bedroom retreats to spacious three-bedroom havens, our diverse floor plans cater to every lifestyle. Keep an eye on your inbox; a team member will be in touch soon!",
  "property_virtualtours_blurb": "At Bolero in vibrant Phoenix, AZ, our thoughtfully designed apartments cater to every lifestyle with spacious one, two, and three-bedroom floor plans. Immerse yourself in modern living by taking a virtual tour of our community and discover your perfect home today! Your oasis awaits!",
  "property_copyright": "2026 All Rights Reserved. Bolero",
  "property_seo_title_home": "Bolero |  Apartments in Phoenix, AZ",
  "property_seo_description_home": "Experience elevated living at Bolero in Phoenix, AZ! Choose from one to three-bedroom apartments with resort-style amenities and a vibrant community vibe.",
  "property_seo_title_floorplans": "Floor Plans | Phoenix, AZ Apartments for Rent",
  "property_seo_description_floorplans": "Find your ideal home at Bolero in Phoenix, AZ! From cozy one-bedroom to spacious three-bedroom layouts, each floor plan complements your lifestyle. Browse now!",
  "property_seo_title_amenities": "Amenities | Phoenix, AZ Apartments for Rent",
  "property_seo_description_amenities": "Experience vibrant living at Bolero in Phoenix! Enjoy top-notch amenities, spacious floor plans, & a welcoming community. Your perfect home awaits!",
  "property_seo_title_gallery": "Gallery | Apartments in Phoenix, AZ",
  "property_seo_description_gallery": "Experience life at Bolero in Phoenix, AZ! Browse stunning photo galleries showcasing spacious floor plans, luxurious amenities, and vibrant community vibes.",
  "property_seo_title_virtualtours": "Virtual Tours | Bolero Apartments",
  "property_seo_description_virtualtours": "Experience luxury living at Bolero in Phoenix, AZ! Take a virtual tour of our stunning one to three-bedroom apartments and envision your new home today!",
  "property_seo_title_interactivemap": "Interactive Map | Bolero Apartments",
  "property_seo_description_interactivemap": "Discover your oasis at Bolero in Phoenix! Use our interactive map to explore spacious 1-3 bedroom apartments and top-notch community amenities.",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Phoenix, AZ",
  "property_seo_description_neighborhood": "Uncover the vibrant lifestyle around Bolero in Phoenix, AZ! Check out local favorites, attractions, and hidden gems just minutes from your new home.",
  "property_seo_title_contact": "Contact Us | Bolero",
  "property_seo_description_contact": "Connect with the Bolero community in Phoenix! Whether you’re looking for one, two, or three-bedroom apartments, our leasing team is here to help.",
  "property_seo_title_faqs": "FAQs | Apartments in Phoenix, AZ",
  "property_seo_description_faqs": "Explore Bolero in Phoenix, AZ—get answers about amenities, pet policy, and more, all tailored for your comfort and convenience!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Phoenix, AZ",
  "property_seo_description_reviews": "Experience life at Bolero in Phoenix, AZ. Our residents rave about spacious layouts, amazing amenities, and a community feel. See their stories and join us!",
  "property_seo_title_applynow": "Apply Now | Apartments in Phoenix, AZ",
  "property_seo_description_applynow": "Discover vibrant living at Bolero, Phoenix! Stylish 1, 2, & 3-bedroom apartments with top amenities await. Lease online today!",
  "property_seo_title_residentaccess": "Resident Access | Bolero",
  "property_seo_description_residentaccess": "Welcome to Bolero in Phoenix, AZ! Log in to your resident portal for hassle-free rent payments, maintenance requests, and community updates at your fingertips.",
  "property_seo_title_referafriend": "Refer A Friend | Bolero",
  "property_seo_description_referafriend": "Refer a friend to Bolero in Phoenix, AZ, where great friends become great neighbors! Share the joy of vibrant living in our welcoming community.",
  "property_seo_title_scheduletour": "Schedule a Tour | Bolero",
  "property_seo_description_scheduletour": "Experience vibrant living at Bolero in Phoenix, AZ. Schedule a tour today and uncover your ideal apartment in our welcoming community!",
  "property_seo_title_privacy": "Privacy Policy | Bolero",
  "property_seo_description_privacy": "At Bolero in Phoenix, AZ, your privacy matters. Discover our commitment to safeguarding your information and view our privacy policy.",
  "property_seo_title_accessibility": "Website Accessibility | Bolero",
  "property_seo_description_accessibility": "At Bolero in Phoenix, AZ, we prioritize accessibility for all. Experience our commitment to digital inclusion for a seamless living experience tailored to you.",
  "property_seo_title_sitemap": "Sitemap | Bolero",
  "property_seo_description_sitemap": "Navigate Bolero’s vibrant community in Phoenix, AZ with ease. Check out our sitemap for a comprehensive look at your future home and all its amenities!",
  "property_seo_title_thankyou": "Thank You | Bolero",
  "property_seo_description_thankyou": "Thank you for reaching out to Bolero in Phoenix! Our team will connect soon to help you find your perfect new home in our vibrant community.",
  "property_seo_title_pets": "Pet Policy | Apartments in Phoenix, AZ",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1791293660819",
  "amenities": [
    {
      "id": "ec_1379b29461924919006131e2",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167137",
      "source": "generator",
      "external_id": "false",
      "title": "Pool",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f9169733a4a07847f973e3a3",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167137",
      "source": "generator",
      "external_id": "false",
      "title": "Fitness Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_2ebaff1b5f6eafa1e3d84b49",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167137",
      "source": "generator",
      "external_id": "false",
      "title": "Controlled Access",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f871322725e14402fab92ce6",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167137",
      "source": "generator",
      "external_id": "false",
      "title": "Grill",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ab5f996f533afdb88068f5c9",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167137",
      "source": "generator",
      "external_id": "false",
      "title": "Gated",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_2052cc9223eee7dc372a5071",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167137",
      "source": "generator",
      "external_id": "false",
      "title": "24 Hour Access",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_253e468749ba7a7df0f44716",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167137",
      "source": "generator",
      "external_id": "false",
      "title": "Bicycle Storage",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f963c0dbe4a2b03ffb7b6719",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167137",
      "source": "generator",
      "external_id": "false",
      "title": "Picnic Area",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_95f0e76a2d16b343cf75935b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167137",
      "source": "generator",
      "external_id": "false",
      "title": "Spa",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ab04295fe49a0289c28640a1",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167137",
      "source": "generator",
      "external_id": "false",
      "title": "Gameroom",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e2c2029790224c7954e04aa2",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167137",
      "source": "generator",
      "external_id": "false",
      "title": "Cabana",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c257d610bcc797a102a2ba24",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167137",
      "source": "generator",
      "external_id": "false",
      "title": "Courtyard",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_823c2b6566a7bee35205ba64",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167137",
      "source": "generator",
      "external_id": "false",
      "title": "Multi Use Room",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d3a4aeb0814656fc5c53f1b1",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167137",
      "source": "generator",
      "external_id": "false",
      "title": "Breakfast/Coffee Concierge",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_8fe23a578e65617b58c607ef",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167137",
      "source": "generator",
      "external_id": "false",
      "title": "Walk‑Up",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_5c11b72644de83cbd9e78a14",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167137",
      "source": "generator",
      "external_id": "false",
      "title": "Property Manager on Site",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_514a16ee87c85586444608f8",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167137",
      "source": "generator",
      "external_id": "false",
      "title": "Renters Insurance Program",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a64572e0a31460077f489740",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167137",
      "source": "generator",
      "external_id": "false",
      "title": "Online Services",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_fe56fe13f7c6662e28b153af",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167137",
      "source": "generator",
      "external_id": "false",
      "title": "Planned Social Activities",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1b82228f1caabe04fdcfc3d7",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167137",
      "source": "generator",
      "external_id": "false",
      "title": "Public Transportation",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_29addb6a59dfea0782e77d7a",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167137",
      "source": "generator",
      "external_id": "false",
      "title": "Washer/Dryer",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_38a43feebcabda91266b124d",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167137",
      "source": "generator",
      "external_id": "false",
      "title": "Air Conditioning",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9be34d9472fa54039bc76675",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167137",
      "source": "generator",
      "external_id": "false",
      "title": "Dishwasher",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4d6ee9222189ce2dd8f275b3",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167137",
      "source": "generator",
      "external_id": "false",
      "title": "High Speed Internet Access",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_37587c05ca2d4d08a699e6eb",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167137",
      "source": "generator",
      "external_id": "false",
      "title": "Hardwood Floors",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f0a4e661302e46d9bfbbee95",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167137",
      "source": "generator",
      "external_id": "false",
      "title": "Walk‑In Closets",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c459a3d9733361e22630ac9c",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167137",
      "source": "generator",
      "external_id": "false",
      "title": "Granite Countertops",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_8f7d9d9a6bb1dd2aeb4be59d",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167137",
      "source": "generator",
      "external_id": "false",
      "title": "Microwave",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_763d388461a9368cdcb9185e",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167137",
      "source": "generator",
      "external_id": "false",
      "title": "Wi‑Fi",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_65c33ff44d58a8cc46f6d83c",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167137",
      "source": "generator",
      "external_id": "false",
      "title": "Heating",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_925fb18260a72bf9b5578716",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167137",
      "source": "generator",
      "external_id": "false",
      "title": "Ceiling Fans",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_5eeb257cefe232fc219ff0aa",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167137",
      "source": "generator",
      "external_id": "false",
      "title": "Smoke Free",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1b96db09c3b0a0cc2841ee73",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167137",
      "source": "generator",
      "external_id": "false",
      "title": "Cable Ready",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_31b3c3e37017c0d6faf09419",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167137",
      "source": "generator",
      "external_id": "false",
      "title": "Security System",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_0ea6c280ceb99be2f85a3cac",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167137",
      "source": "generator",
      "external_id": "false",
      "title": "Double Vanities",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_26933d755c2ca9aac3613906",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167137",
      "source": "generator",
      "external_id": "false",
      "title": "Tub/Shower",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_acccb5da34de438c13bdef65",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167137",
      "source": "generator",
      "external_id": "false",
      "title": "Wheelchair Accessible (Rooms)",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_fd6864c68bcbf5b318023e5a",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167137",
      "source": "generator",
      "external_id": "false",
      "title": "Disposal",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_177cf99226737b542ed06835",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167137",
      "source": "generator",
      "external_id": "false",
      "title": "Ice Maker",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_77580204c51e10bf0b19b10a",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167137",
      "source": "generator",
      "external_id": "false",
      "title": "Pantry",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_2bb003d99e1f9498a64d508a",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167137",
      "source": "generator",
      "external_id": "false",
      "title": "Oven",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_76de5a7d7a67c0169ef01f28",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167137",
      "source": "generator",
      "external_id": "false",
      "title": "Range",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e3d8eeb93ac129693b1a7542",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167137",
      "source": "generator",
      "external_id": "false",
      "title": "Refrigerator",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9573cf30882a9cb8c533c4d5",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167137",
      "source": "generator",
      "external_id": "false",
      "title": "Freezer",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e9bd1e618e7130a4352309b8",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167137",
      "source": "generator",
      "external_id": "false",
      "title": "Balcony",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_163e277e2cacc804b9ff3a99",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167137",
      "source": "generator",
      "external_id": "false",
      "title": "Patio",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "ec_1027c645216989eedcbd2849",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167137",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167137/019d0215-31af-7667-8f3d-c3334e0b4209.webp",
      "image_media": {
        "alt_text": "Living room with a sofa, coffee table, dining table, and artwork.",
        "public_id": "019d0215-31af-7667-8f3d-c3334e0b4209",
        "storage_key": "property/6767906449167137/019d0215-31af-7667-8f3d-c3334e0b4209.webp",
        "width": 2000,
        "height": 1126
      },
      "title": "Apartment",
      "description": "Spacious living area featuring a comfortable sofa, a decorative coffee table, and a separate dining area, perfect for relaxing and entertaining.",
      "link": "false",
      "alt_text": "Living room with a sofa, coffee table, dining table, and artwork.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AZ_Bolero_Favorites (34).jpg"
    },
    {
      "id": "ec_972bbd371a1fbcca86403ffb",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167137",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167137/019d0215-31b2-7163-8a5d-97e4b21f2a52.webp",
      "image_media": {
        "alt_text": "A well-decorated living room with a sectional sofa, coffee table, and a TV mounted on the wall.",
        "public_id": "019d0215-31b2-7163-8a5d-97e4b21f2a52",
        "storage_key": "property/6767906449167137/019d0215-31b2-7163-8a5d-97e4b21f2a52.webp",
        "width": 2000,
        "height": 1125
      },
      "title": "Apartment",
      "description": "Spacious living area featuring comfortable seating, a modern coffee table, and a wall-mounted television, perfect for relaxation and entertainment.",
      "link": "false",
      "alt_text": "A well-decorated living room with a sectional sofa, coffee table, and a TV mounted on the wall.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AZ_Bolero_Favorites (33).jpg"
    },
    {
      "id": "ec_cd4ef2a6397d61a26186299f",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167137",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167137/019d0215-31af-7667-8f3d-c4bca769a80c.webp",
      "image_media": {
        "alt_text": "Modern living room with dark sofa, accent chairs, coffee table, and view of kitchen.",
        "public_id": "019d0215-31af-7667-8f3d-c4bca769a80c",
        "storage_key": "property/6767906449167137/019d0215-31af-7667-8f3d-c4bca769a80c.webp",
        "width": 2000,
        "height": 1125
      },
      "title": "Apartment",
      "description": "Step into comfort in this stylish living area, featuring a plush sofa, elegant accent chairs, and a modern coffee table. The open-concept design flows seamlessly into a well-appointed kitchen, perfect for entertaining or everyday living.",
      "link": "false",
      "alt_text": "Modern living room with dark sofa, accent chairs, coffee table, and view of kitchen.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AZ_Bolero_Favorites (22).jpg"
    },
    {
      "id": "ec_ac67bdea69fec59eef18fce0",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167137",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167137/019e724e-d068-72de-95e8-217608464661.webp",
      "image_media": {
        "alt_text": "Living room and kitchen area of an apartment",
        "public_id": "019e724e-d068-72de-95e8-217608464661",
        "storage_key": "property/6767906449167137/019e724e-d068-72de-95e8-217608464661.webp",
        "width": 2000,
        "height": 1125
      },
      "title": "Apartment",
      "description": "A bright and spacious living and dining area adjacent to a modern kitchen, perfect for entertaining.",
      "link": "false",
      "alt_text": "Living room and kitchen area of an apartment",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AZ_Bolero_Favorites (28).jpg"
    },
    {
      "id": "ec_2437c027c8c57221ae46cff7",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167137",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167137/019d0215-3bf0-7319-861e-c7713bb50a8f.webp",
      "image_media": {
        "alt_text": "Dining area and kitchen in apartment.",
        "public_id": "019d0215-3bf0-7319-861e-c7713bb50a8f",
        "storage_key": "property/6767906449167137/019d0215-3bf0-7319-861e-c7713bb50a8f.webp",
        "width": 2000,
        "height": 1334
      },
      "title": "Apartment",
      "description": "Dining area and kitchen in apartment.",
      "link": "false",
      "alt_text": "Dining area and kitchen in apartment.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AZ_Bolero_Favorites (31).jpg"
    },
    {
      "id": "ec_5e9c13717fe63377eb53c14b",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167137",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167137/019d0215-3cbc-73c0-9217-d3c0333e0b1f.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances and white cabinetry.",
        "public_id": "019d0215-3cbc-73c0-9217-d3c0333e0b1f",
        "storage_key": "property/6767906449167137/019d0215-3cbc-73c0-9217-d3c0333e0b1f.webp",
        "width": 2000,
        "height": 1125
      },
      "title": "Apartment",
      "description": "Enjoy cooking in this stylish kitchen featuring a double sink, ample cabinet space, and a full-size refrigerator and stove.",
      "link": "false",
      "alt_text": "Modern kitchen with stainless steel appliances and white cabinetry.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AZ_Bolero_Favorites (18).jpg"
    },
    {
      "id": "ec_696d3f42d58e7523d69dc3d9",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167137",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167137/019d0215-3f4e-700d-b198-a97a7e3ced0c.webp",
      "image_media": {
        "alt_text": "Kitchen with stainless steel appliances, granite countertops, and light wood cabinets.",
        "public_id": "019d0215-3f4e-700d-b198-a97a7e3ced0c",
        "storage_key": "property/6767906449167137/019d0215-3f4e-700d-b198-a97a7e3ced0c.webp",
        "width": 2000,
        "height": 1126
      },
      "title": "Apartment",
      "description": "Modern kitchen featuring a double sink, dishwasher, oven, microwave, and ample cabinet space for storage.",
      "link": "false",
      "alt_text": "Kitchen with stainless steel appliances, granite countertops, and light wood cabinets.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AZ_Bolero_Favorites (29).jpg"
    },
    {
      "id": "ec_4f5029cab7cfa76e253a19da",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167137",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167137/019e724e-e206-7313-b239-d9ea2077a8dc.webp",
      "image_media": {
        "alt_text": "Modern kitchen with wood cabinets, granite countertops, stainless steel appliances, and a double sink.",
        "public_id": "019e724e-e206-7313-b239-d9ea2077a8dc",
        "storage_key": "property/6767906449167137/019e724e-e206-7313-b239-d9ea2077a8dc.webp",
        "width": 2000,
        "height": 1334
      },
      "title": "Apartment",
      "description": "Explore the heart of your home in this beautifully appointed kitchen, featuring elegant wood cabinetry, durable granite countertops, and modern stainless steel appliances for a sophisticated cooking experience.",
      "link": "false",
      "alt_text": "Modern kitchen with wood cabinets, granite countertops, stainless steel appliances, and a double sink.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AZ_Bolero_Favorites (27).jpg"
    },
    {
      "id": "ec_34e30cba756b55744f02341d",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167137",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167137/019d0215-477a-70a6-a99f-d39e17a792cc.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel sink, black dishwasher, black refrigerator, and black stove.",
        "public_id": "019d0215-477a-70a6-a99f-d39e17a792cc",
        "storage_key": "property/6767906449167137/019d0215-477a-70a6-a99f-d39e17a792cc.webp",
        "width": 2000,
        "height": 1334
      },
      "title": "Apartment",
      "description": "Bright and modern kitchen featuring a large stainless steel sink, a dishwasher, a refrigerator, and a stovetop. The ample cabinet space and sleek countertops make this kitchen a chef's dream.",
      "link": "false",
      "alt_text": "Modern kitchen with stainless steel sink, black dishwasher, black refrigerator, and black stove.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AZ_Bolero_Favorites (26).jpg"
    },
    {
      "id": "ec_4da6a33fbd2ac7b69bb53797",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167137",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167137/019e724e-e334-75a3-b6b5-f0246611c4a2.webp",
      "image_media": {
        "alt_text": "Bedroom with a queen-size bed, nightstand, dresser, and ceiling fan.",
        "public_id": "019e724e-e334-75a3-b6b5-f0246611c4a2",
        "storage_key": "property/6767906449167137/019e724e-e334-75a3-b6b5-f0246611c4a2.webp",
        "width": 2000,
        "height": 1334
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a comfortable queen-size bed, elegant nightstand with a lamp, and a chest of drawers for storage. A ceiling fan provides added comfort.",
      "link": "false",
      "alt_text": "Bedroom with a queen-size bed, nightstand, dresser, and ceiling fan.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AZ_Bolero_Favorites (30).jpg"
    },
    {
      "id": "ec_03f1f4dcd9055df8a67b57ad",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167137",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167137/019e724e-e398-7128-9dfd-c6f8f31570c4.webp",
      "image_media": {
        "alt_text": "Bedroom with a queen-size bed, artwork, and a window.",
        "public_id": "019e724e-e398-7128-9dfd-c6f8f31570c4",
        "storage_key": "property/6767906449167137/019e724e-e398-7128-9dfd-c6f8f31570c4.webp",
        "width": 2000,
        "height": 1125
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a comfortable queen-size bed, decorative artwork, and ample natural light from a large window.",
      "link": "false",
      "alt_text": "Bedroom with a queen-size bed, artwork, and a window.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AZ_Bolero_Favorites (24).jpg"
    },
    {
      "id": "ec_1fd4a856ebcd920aaeb12c06",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167137",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167137/019d0215-50c1-73a6-822f-1ed43dddbc37.webp",
      "image_media": {
        "alt_text": "Bathroom vanity with double sinks and wood cabinets, opposite bathtub, shower, and toilet.",
        "public_id": "019d0215-50c1-73a6-822f-1ed43dddbc37",
        "storage_key": "property/6767906449167137/019d0215-50c1-73a6-822f-1ed43dddbc37.webp",
        "width": 2000,
        "height": 1125
      },
      "title": "Apartment",
      "description": "Enjoy this bright and modern bathroom with double sinks, ample storage, and a clean, classic shower and tub combination.",
      "link": "false",
      "alt_text": "Bathroom vanity with double sinks and wood cabinets, opposite bathtub, shower, and toilet.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AZ_Bolero_Favorites (23).jpg"
    },
    {
      "id": "ec_79c55d002006968b79ae5c7f",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167137",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167137/019e724e-f291-7437-ba7f-efd1888203b9.webp",
      "image_media": {
        "alt_text": "Bathroom with bathtub, toilet, and vanity with sink.",
        "public_id": "019e724e-f291-7437-ba7f-efd1888203b9",
        "storage_key": "property/6767906449167137/019e724e-f291-7437-ba7f-efd1888203b9.webp",
        "width": 2000,
        "height": 1125
      },
      "title": "Apartment",
      "description": "Spacious bathroom featuring a bathtub, toilet, and a modern vanity with a sink and ample counter space.",
      "link": "false",
      "alt_text": "Bathroom with bathtub, toilet, and vanity with sink.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AZ_Bolero_Favorites (32).jpg"
    },
    {
      "id": "ec_251a84e69ac698f6fb2d92d6",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167137",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167137/019d0215-51f6-7060-873a-a684e18f4514.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool and jacuzzi with lounge chairs and palm trees.",
        "public_id": "019d0215-51f6-7060-873a-a684e18f4514",
        "storage_key": "property/6767906449167137/019d0215-51f6-7060-873a-a684e18f4514.webp",
        "width": 2000,
        "height": 1334
      },
      "title": "Community",
      "description": "Enjoy a relaxing day by the sparkling swimming pool and soothing jacuzzi. Perfect for unwinding after a long day.",
      "link": "false",
      "alt_text": "Outdoor swimming pool and jacuzzi with lounge chairs and palm trees.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AZ_Bolero_Favorites (21).jpg"
    },
    {
      "id": "ec_3fc6effa84488f8109ec205e",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167137",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167137/019e724e-f585-74e4-a366-f0ad466f7b08.webp",
      "image_media": {
        "alt_text": "Fitness center with treadmills, ellipticals, and weight machines.",
        "public_id": "019e724e-f585-74e4-a366-f0ad466f7b08",
        "storage_key": "property/6767906449167137/019e724e-f585-74e4-a366-f0ad466f7b08.webp",
        "width": 2000,
        "height": 1334
      },
      "title": "Community",
      "description": "Stay active in our fully equipped fitness center, featuring cardio machines and strength training equipment.",
      "link": "false",
      "alt_text": "Fitness center with treadmills, ellipticals, and weight machines.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AZ_Bolero_Favorites (20).jpg"
    },
    {
      "id": "ec_937ffd2ac968d6ac890bd1bf",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167137",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167137/019e724e-f64c-72be-844a-fa4d06b3d8de.webp",
      "image_media": {
        "alt_text": "Lobby area with seating, fireplace, and view of the pool and lounge chairs.",
        "public_id": "019e724e-f64c-72be-844a-fa4d06b3d8de",
        "storage_key": "property/6767906449167137/019e724e-f64c-72be-844a-fa4d06b3d8de.webp",
        "width": 2000,
        "height": 1126
      },
      "title": "Community",
      "description": "Relax and unwind by our stunning outdoor pool, visible from the comfortable lobby area.",
      "link": "false",
      "alt_text": "Lobby area with seating, fireplace, and view of the pool and lounge chairs.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AZ_Bolero_Favorites (25).jpg"
    },
    {
      "id": "ec_f224af7b0f01a741cd8ae2ae",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167137",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167137/019d0215-5ce5-7344-9195-f1f923bb22a4.webp",
      "image_media": {
        "alt_text": "Community coffee and water station with artwork.",
        "public_id": "019d0215-5ce5-7344-9195-f1f923bb22a4",
        "storage_key": "property/6767906449167137/019d0215-5ce5-7344-9195-f1f923bb22a4.webp",
        "width": 2000,
        "height": 1126
      },
      "title": "Community",
      "description": "Enjoy complimentary coffee and refreshments at our community coffee and water station. Featuring modern appliances and tasteful decor.",
      "link": "false",
      "alt_text": "Community coffee and water station with artwork.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AZ_Bolero_Favorites (19).jpg"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_a2aedefa-ab40-4c7d-8b42-770c1ee4e28a",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167137",
      "source": "custom",
      "poi_name": "Topgolf Glendale",
      "poi_type": "Restaurants",
      "poi_address": "6101 N 99th Ave, Glendale, AZ 85305, USA",
      "poi_short_description": "Comfort food, beers, and cocktails are served in a relaxed restaurant with a golf driving range.",
      "poi_long_description": "Visitors say this entertainment venue offers a fun, family-friendly atmosphere with interactive golf games, a lively bar, and delicious food, including unique donut holes. They also highlight the friendly and helpful staff, as well as the clean and well-maintained facilities.\n\nSome reviews mention the service can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167137/019d0216-84bc-7414-9d39-9e5177302ee4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0216-84bc-7414-9d39-9e5177302ee4",
        "storage_key": "property/6767906449167137/019d0216-84bc-7414-9d39-9e5177302ee4.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://topgolf.com/us/glendale/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18202148712618417323&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "topgolf-glendale",
      "poi_latitude": "33.5244195",
      "poi_longitude": "-112.2708168",
      "poi_miles_from_property": "6.9",
      "poi_walking_minutes": "2 hours 31 mins",
      "poi_biking_minutes": "44 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 623-218-2243",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167137/019d0216-446e-74da-8c85-a263a6ac5ce2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0216-446e-74da-8c85-a263a6ac5ce2",
        "storage_key": "property/6767906449167137/019d0216-446e-74da-8c85-a263a6ac5ce2.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJEeFArr5BK4cRq1x0pNAFm_w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_3bbcddf2-a0a3-4db2-85ce-65539abc33ee",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167137",
      "source": "custom",
      "poi_name": "In-N-Out Burger",
      "poi_type": "Restaurants",
      "poi_address": "9585 W Camelback Rd, Phoenix, AZ 85037, USA",
      "poi_short_description": "Classic burger chain serving customizable burgers, hand-cut fries & shakes.",
      "poi_long_description": "Diners say this hamburger restaurant serves delicious cheeseburgers, shakes, and fries. They also highlight the friendly staff, fast service, and great prices.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167137/019d0216-850a-709a-b616-41ca8c7be6b9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0216-850a-709a-b616-41ca8c7be6b9",
        "storage_key": "property/6767906449167137/019d0216-850a-709a-b616-41ca8c7be6b9.webp",
        "width": 1280,
        "height": 702
      },
      "poi_business_url": "https://locations.in-n-out.com/232",
      "poi_directions_map_url": "https://maps.google.com/?cid=9269979748906429610&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "in-n-out-burger",
      "poi_latitude": "33.508033",
      "poi_longitude": "-112.2664839",
      "poi_miles_from_property": "5.5",
      "poi_walking_minutes": "2 hours 1 min",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 800-786-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167137/019d0216-446e-74da-8c85-a263a6ac5ce2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0216-446e-74da-8c85-a263a6ac5ce2",
        "storage_key": "property/6767906449167137/019d0216-446e-74da-8c85-a263a6ac5ce2.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJqQqcbmxAK4cRquyhmHeVpYA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hamburger_restaurant"
    },
    {
      "id": "custom_5046e90a-bc93-4ece-8b6f-b3ab8840f10a",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167137",
      "source": "custom",
      "poi_name": "Tacos Los Vales",
      "poi_type": "Restaurants",
      "poi_address": "5124 W McDowell Rd, Phoenix, AZ 85035, USA",
      "poi_short_description": "Casual spot in McDowell Square Shopping Center serving Mexican specialties including tacos and birria, plus quesadillas.",
      "poi_long_description": "People say this Mexican restaurant serves delicious tacos, quesabirria, and birria. They highlight the generous portions, fresh salsa bar, and authentic flavors. They also like the friendly and attentive service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167137/019d0216-869d-7074-8c93-59f48d2c6528.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0216-869d-7074-8c93-59f48d2c6528",
        "storage_key": "property/6767906449167137/019d0216-869d-7074-8c93-59f48d2c6528.webp",
        "width": 1226,
        "height": 1280
      },
      "poi_business_url": "https://tacoslosvales.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4124644957025242092&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "tacos-los-vales",
      "poi_latitude": "33.4673611",
      "poi_longitude": "-112.1709139",
      "poi_miles_from_property": "3.4",
      "poi_walking_minutes": "1 hour 17 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 602-237-6315",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167137/019d0216-446e-74da-8c85-a263a6ac5ce2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0216-446e-74da-8c85-a263a6ac5ce2",
        "storage_key": "property/6767906449167137/019d0216-446e-74da-8c85-a263a6ac5ce2.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJb_JpQoYVK4cR7IsYMLyuPTk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "custom_380c1626-7d88-467d-b38f-e17158a52500",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167137",
      "source": "custom",
      "poi_name": "Yard House",
      "poi_type": "Restaurants",
      "poi_address": "9401 W Westgate Blvd, Glendale, AZ 85305, USA",
      "poi_short_description": "High-end sports-bar chain with a huge menu of New American fare & an extensive list of draft beers.",
      "poi_long_description": "People say this restaurant offers delicious jambalaya, burgers, and calamari, and has a massive selection of beers on tap. They highlight the generous portions, reasonable prices, and lively atmosphere. They also like the friendly and attentive service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167137/019d0216-85f8-740a-a3e9-e5adf01deb1d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0216-85f8-740a-a3e9-e5adf01deb1d",
        "storage_key": "property/6767906449167137/019d0216-85f8-740a-a3e9-e5adf01deb1d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.yardhouse.com/locations/az/glendale/glendale-westgate-entertainment-district/8315?cmpid=br:yh_ag:ie_ch:loc_ca:YHGMB_sn:gmb_gt:glendale-az-8315_pl:locurl_rd:1014",
      "poi_directions_map_url": "https://maps.google.com/?cid=834847278677342726&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "yard-house",
      "poi_latitude": "33.5340858",
      "poi_longitude": "-112.2612644",
      "poi_miles_from_property": "6.8",
      "poi_walking_minutes": "2 hours 30 mins",
      "poi_biking_minutes": "44 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 623-872-3900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167137/019d0216-446e-74da-8c85-a263a6ac5ce2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0216-446e-74da-8c85-a263a6ac5ce2",
        "storage_key": "property/6767906449167137/019d0216-446e-74da-8c85-a263a6ac5ce2.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJdW2bezVAK4cRBrpDPy35lQs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_df765a27-edab-41fa-b407-70e7059dd883",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167137",
      "source": "custom",
      "poi_name": "Chicken N Pickle - Glendale",
      "poi_type": "Restaurants",
      "poi_address": "9330 W Hanna Ln, Glendale, AZ 85305, USA",
      "poi_short_description": "Rotisserie chicken and other comfort food share a menu with beer, cocktails, and pickleball courts.",
      "poi_long_description": "People say this restaurant offers delicious rotisserie chicken, creative salads, and tasty sandwiches. They also highlight the vibrant, playful atmosphere with pickleball courts and yard games, and the friendly, attentive service.\n\nOther reviews mention the food can be inconsistent.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167137/019d0216-8aaa-778b-b3d7-293086708e72.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0216-8aaa-778b-b3d7-293086708e72",
        "storage_key": "property/6767906449167137/019d0216-8aaa-778b-b3d7-293086708e72.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://chickennpickle.com/location/glendale/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10503486576134877276&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "chicken-n-pickle---glendale",
      "poi_latitude": "33.5355509",
      "poi_longitude": "-112.2599241",
      "poi_miles_from_property": "6.8",
      "poi_walking_minutes": "2 hours 29 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 623-352-8950",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167137/019d0216-446e-74da-8c85-a263a6ac5ce2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0216-446e-74da-8c85-a263a6ac5ce2",
        "storage_key": "property/6767906449167137/019d0216-446e-74da-8c85-a263a6ac5ce2.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJZf1ynU1BK4cRXHCaIWThw5E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_039592c2-fdeb-4d04-92c9-ff3cda8052d0",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167137",
      "source": "custom",
      "poi_name": "Tanger Outlets Phoenix",
      "poi_type": "Shopping & Retail",
      "poi_address": "6800 N 95th Ave, Glendale, AZ 85305, USA",
      "poi_short_description": "Shopping-mall chain featuring a variety of brand-name & designer outlet stores.",
      "poi_long_description": "People say this shopping center offers a wide variety of brands, stores, and shoes. They highlight the good deals, clean environment, and convenient parking. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167137/019d0216-89eb-709d-a4e3-145c880f2897.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0216-89eb-709d-a4e3-145c880f2897",
        "storage_key": "property/6767906449167137/019d0216-89eb-709d-a4e3-145c880f2897.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.tangeroutlet.com/glendale",
      "poi_directions_map_url": "https://maps.google.com/?cid=16253464825419077885&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "tanger-outlets-phoenix",
      "poi_latitude": "33.5341547",
      "poi_longitude": "-112.2667464",
      "poi_miles_from_property": "7.1",
      "poi_walking_minutes": "2 hours 37 mins",
      "poi_biking_minutes": "45 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 623-877-9500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167137/019d0216-49da-7669-b7a0-5ec404eafc81.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0216-49da-7669-b7a0-5ec404eafc81",
        "storage_key": "property/6767906449167137/019d0216-49da-7669-b7a0-5ec404eafc81.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJNyV8OEtAK4cR_Rhp6CToj-E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_f9b4a66f-d607-4b68-acd1-bce793cd4dc5",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167137",
      "source": "custom",
      "poi_name": "Desert Sky Mall",
      "poi_type": "Shopping & Retail",
      "poi_address": "7611 W Thomas Rd, Phoenix, AZ 85033, USA",
      "poi_short_description": "Indoor mall with national/local shops, dining & live entertainment on the weekends.",
      "poi_long_description": "People say this shopping center offers a variety of stores, including a Mexican market, and a diverse food court with options like Chinese food and Philly cheesesteaks. They also highlight the good deals, the fun atmosphere with a carousel and train, and the availability of Spanish-speaking vendors.\n\nOther reviews mention the mall can be run-down.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167137/019d0216-2ab7-76cc-9106-15b3ac63d0f5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0216-2ab7-76cc-9106-15b3ac63d0f5",
        "storage_key": "property/6767906449167137/019d0216-2ab7-76cc-9106-15b3ac63d0f5.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.desertskymall.com/?utm_source=google&utm_medium=onlinesearch&utm_content=gmp_website_button&utm_campaign=yext",
      "poi_directions_map_url": "https://maps.google.com/?cid=5353196390973648747&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "desert-sky-mall",
      "poi_latitude": "33.4769375",
      "poi_longitude": "-112.2249003",
      "poi_miles_from_property": "1",
      "poi_walking_minutes": "23 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 623-245-1400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167137/019d0216-49da-7669-b7a0-5ec404eafc81.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0216-49da-7669-b7a0-5ec404eafc81",
        "storage_key": "property/6767906449167137/019d0216-49da-7669-b7a0-5ec404eafc81.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJryIPX2gVK4cRay_jUMFfSko",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_445d0ca6-5a74-4af4-87b5-da4e507bd614",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167137",
      "source": "custom",
      "poi_name": "American Furniture Warehouse",
      "poi_type": "Shopping & Retail",
      "poi_address": "5801 N 99th Ave, Glendale, AZ 85305, USA",
      "poi_short_description": "Retailer selling a variety of furniture, including outdoor pieces, plus home-decor items & artwork.",
      "poi_long_description": "Shoppers say this furniture store offers a wide variety of couches, recliners, and patio furniture at affordable prices, with quick and professional delivery. They also highlight the friendly and helpful staff, and the efficient purchase and delivery process.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167137/019d0216-8d90-741e-877b-5c0fc2d01005.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0216-8d90-741e-877b-5c0fc2d01005",
        "storage_key": "property/6767906449167137/019d0216-8d90-741e-877b-5c0fc2d01005.webp",
        "width": 600,
        "height": 337
      },
      "poi_business_url": "https://www.afw.com/stores/az/glendale?utm_campaign=googlelocal&utm_source=google&utm_medium=local&utm_content=afw-glendale-az",
      "poi_directions_map_url": "https://maps.google.com/?cid=13289684229149210779&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "american-furniture-warehouse",
      "poi_latitude": "33.5184",
      "poi_longitude": "-112.2704781",
      "poi_miles_from_property": "6.6",
      "poi_walking_minutes": "2 hours 26 mins",
      "poi_biking_minutes": "45 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 602-422-8800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167137/019d0216-49da-7669-b7a0-5ec404eafc81.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0216-49da-7669-b7a0-5ec404eafc81",
        "storage_key": "property/6767906449167137/019d0216-49da-7669-b7a0-5ec404eafc81.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJbyhc60RAK4cRm7iMB2Vxbrg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "furniture_store"
    },
    {
      "id": "custom_90b9cb3d-ecbe-4d14-a620-946bba79e0c5",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167137",
      "source": "custom",
      "poi_name": "The Home Depot",
      "poi_type": "Shopping & Retail",
      "poi_address": "7333 W McDowell Rd, Phoenix, AZ 85035, USA",
      "poi_short_description": "Chain home improvement retailer for tools, appliances & other products (some offer truck rentals).",
      "poi_long_description": "People say this home improvement store offers a wide variety of products. They also highlight the helpful staff and the convenient phone app for finding items.\n\nOther reviews mention the service can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167137/019d0215-ebc7-745a-9002-461f34354872.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0215-ebc7-745a-9002-461f34354872",
        "storage_key": "property/6767906449167137/019d0215-ebc7-745a-9002-461f34354872.webp",
        "width": 704,
        "height": 292
      },
      "poi_business_url": "https://www.homedepot.com/l/Mcdowell/AZ/Phoenix/85035/455?emt=MSGMBGoogleMaps",
      "poi_directions_map_url": "https://maps.google.com/?cid=13181049534492807327&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "the-home-depot",
      "poi_latitude": "33.4645183",
      "poi_longitude": "-112.2179712",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "16 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 623-849-1200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167137/019d0216-49da-7669-b7a0-5ec404eafc81.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0216-49da-7669-b7a0-5ec404eafc81",
        "storage_key": "property/6767906449167137/019d0216-49da-7669-b7a0-5ec404eafc81.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJS5Q8kHMVK4cRn5BFJrd-7LY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_improvement_store"
    },
    {
      "id": "custom_ba139406-76a3-4ad0-942c-de5bd3374d0e",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167137",
      "source": "custom",
      "poi_name": "State Farm Stadium",
      "poi_type": "Entertainment",
      "poi_address": "1 Cardinals Dr, Glendale, AZ 85305, USA",
      "poi_short_description": "Home of NFL Cardinals games & more, this arena seats 63,000+ & features a retracting roof.",
      "poi_long_description": "People say this stadium offers a variety of events, including concerts, sports games, and shows. They highlight the reasonable prices, clean facilities, and comfortable air conditioning. They also like the friendly and helpful staff, and the organized parking and traffic flow. ",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167137/019d0216-8fab-700c-aabe-edbc4cf0102a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0216-8fab-700c-aabe-edbc4cf0102a",
        "storage_key": "property/6767906449167137/019d0216-8fab-700c-aabe-edbc4cf0102a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.statefarmstadium.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13385990751358890075&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "state-farm-stadium",
      "poi_latitude": "33.5276247",
      "poi_longitude": "-112.2625593",
      "poi_miles_from_property": "6.4",
      "poi_walking_minutes": "2 hours 21 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 623-433-7101",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167137/019d0216-4f92-7059-a4fd-c2a1cec5a8ac.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0216-4f92-7059-a4fd-c2a1cec5a8ac",
        "storage_key": "property/6767906449167137/019d0216-4f92-7059-a4fd-c2a1cec5a8ac.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ3UCqTEhAK4cRWzBplaqXxLk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "stadium"
    },
    {
      "id": "custom_3dee7f77-51d2-4796-800a-fc81d3369d66",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167137",
      "source": "custom",
      "poi_name": "Desert Diamond Arena",
      "poi_type": "Entertainment",
      "poi_address": "9400 W Maryland Ave, Glendale, AZ 85305, USA",
      "poi_short_description": "Celebrated multipurpose facility showcases Phoenix Coyotes games, other sporting events & concerts.",
      "poi_long_description": "People say this arena hosts great events and has easy parking, with options including a parking garage located near the entrance. They also highlight the excellent sound and visual systems.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167137/019d0216-91c7-73fa-abdf-f81355c120fa.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0216-91c7-73fa-abdf-f81355c120fa",
        "storage_key": "property/6767906449167137/019d0216-91c7-73fa-abdf-f81355c120fa.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.desertdiamondarena.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5185020725397653236&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "desert-diamond-arena",
      "poi_latitude": "33.532074",
      "poi_longitude": "-112.2612163",
      "poi_miles_from_property": "6.6",
      "poi_walking_minutes": "2 hours 27 mins",
      "poi_biking_minutes": "43 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 623-249-2603",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167137/019d0216-4fa2-70ce-add6-233c721bc076.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0216-4fa2-70ce-add6-233c721bc076",
        "storage_key": "property/6767906449167137/019d0216-4fa2-70ce-add6-233c721bc076.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJy-l2-zVAK4cR9IZd2uDk9Ec",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "arena"
    },
    {
      "id": "custom_3fe2ce03-3c16-4c6d-952d-18c1fd15b92e",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167137",
      "source": "custom",
      "poi_name": "Camelback Ranch - Glendale",
      "poi_type": "Entertainment",
      "poi_address": "10710 W Camelback Rd, Phoenix, AZ 85037, USA",
      "poi_short_description": "Sizable stadium hosting spring training games for the Los Angeles Dodgers & the Chicago White Sox.",
      "poi_long_description": "People say this stadium is a great place to watch spring training baseball games, with a beautiful field and comfortable seating. They highlight the free parking, clean facilities, and friendly staff. They also like the variety of concessions and the fun, family-friendly atmosphere.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167137/019d0216-9259-73eb-bbea-a8603153f45b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0216-9259-73eb-bbea-a8603153f45b",
        "storage_key": "property/6767906449167137/019d0216-9259-73eb-bbea-a8603153f45b.webp",
        "width": 1280,
        "height": 735
      },
      "poi_business_url": "http://camelbackranchbaseball.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4078120371554765057&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "camelback-ranch---glendale",
      "poi_latitude": "33.5140994",
      "poi_longitude": "-112.2958463",
      "poi_miles_from_property": "8",
      "poi_walking_minutes": "2 hours 56 mins",
      "poi_biking_minutes": "51 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 623-302-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167137/019d0216-4f92-7059-a4fd-c2a1cec5a8ac.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0216-4f92-7059-a4fd-c2a1cec5a8ac",
        "storage_key": "property/6767906449167137/019d0216-4f92-7059-a4fd-c2a1cec5a8ac.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJXwN8zPNAK4cRAUnOAd9kmDg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "stadium"
    },
    {
      "id": "custom_3d6da792-5bb9-486d-8797-3babf06c0963",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167137",
      "source": "custom",
      "poi_name": "American Family Fields of Phoenix",
      "poi_type": "Entertainment",
      "poi_address": "3805 N 53rd Ave, Phoenix, AZ 85031, USA",
      "poi_short_description": "Spring training facility for the Milwaukee Brewers with minor league programs & community leagues.",
      "poi_long_description": "People say this stadium offers great views of the field and a fun game experience. They also highlight the friendly staff and the convenient golf cart shuttles from the parking lot.\n\nOther reviews mention the parking can be difficult.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167137/019d0216-9450-75b2-80c1-a5bed401b237.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0216-9450-75b2-80c1-a5bed401b237",
        "storage_key": "property/6767906449167137/019d0216-9450-75b2-80c1-a5bed401b237.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.mlb.com/brewers/spring-training/ballpark",
      "poi_directions_map_url": "https://maps.google.com/?cid=6884078747193824678&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "american-family-fields-of-phoenix",
      "poi_latitude": "33.492228",
      "poi_longitude": "-112.1723735",
      "poi_miles_from_property": "5.2",
      "poi_walking_minutes": "1 hour 56 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 623-245-5500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167137/019d0216-4f92-7059-a4fd-c2a1cec5a8ac.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0216-4f92-7059-a4fd-c2a1cec5a8ac",
        "storage_key": "property/6767906449167137/019d0216-4f92-7059-a4fd-c2a1cec5a8ac.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJgcpYLMIUK4cRptVNrCUpiV8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "stadium"
    },
    {
      "id": "custom_936e8c73-2278-4948-92b2-35a6eaf5b011",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167137",
      "source": "custom",
      "poi_name": "Mattel Adventure Park",
      "poi_type": "Entertainment",
      "poi_address": "9601 Cardinals Wy, Glendale, AZ 85305, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this theme park offers fun rides and attractions suitable for families. They also highlight the low attendance, which means shorter lines, and the option to bring your own food and snacks.\n\nOther reviews mention some rides may not be open.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167137/019d0216-979c-729d-8d11-0bb29f1546a4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0216-979c-729d-8d11-0bb29f1546a4",
        "storage_key": "property/6767906449167137/019d0216-979c-729d-8d11-0bb29f1546a4.webp",
        "width": 1280,
        "height": 1178
      },
      "poi_business_url": "https://www.matteladventurepark.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3689948113383770327&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "mattel-adventure-park",
      "poi_latitude": "33.51874129999999",
      "poi_longitude": "-112.2665389",
      "poi_miles_from_property": "6.2",
      "poi_walking_minutes": "2 hours 16 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167137/019d0216-4fa2-70ce-add6-233c721bc076.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0216-4fa2-70ce-add6-233c721bc076",
        "storage_key": "property/6767906449167137/019d0216-4fa2-70ce-add6-233c721bc076.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJCYZ-ODNBK4cR18jcSUJUNTM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_center"
    },
    {
      "id": "custom_2daff79a-720b-488e-b26b-06961f43e9fb",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167137",
      "source": "custom",
      "poi_name": "EōS Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "7400 W Encanto Blvd, Phoenix, AZ 85035, USA",
      "poi_short_description": "High-value gym chain featuring a variety of equipment, plus group classes, and a pool.",
      "poi_long_description": "People say this gym has a wide variety of modern, clean equipment, and a friendly, helpful staff. They also highlight the gym's spacious layout, convenient location, and great value for the price.\n\nSome reviews mention the gym can be crowded during peak hours.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167137/019d0216-1452-7445-8593-a501317af0f8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0216-1452-7445-8593-a501317af0f8",
        "storage_key": "property/6767906449167137/019d0216-1452-7445-8593-a501317af0f8.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://eosfitness.com/gym/phoenix-75th-aveencanto/?utm_source=local&utm_medium=organic&utm_campaign=evergreen_gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=15695482801901019761&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "es-fitness",
      "poi_latitude": "33.4738021",
      "poi_longitude": "-112.2183848",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "26 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 480-210-6729",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167137/019d0216-4fa2-70ce-add6-233c721bc076.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0216-4fa2-70ce-add6-233c721bc076",
        "storage_key": "property/6767906449167137/019d0216-4fa2-70ce-add6-233c721bc076.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJW-usFT8VK4cRcSKQOXOO0dk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_af13ec39-b98c-4550-b528-31c1672ceb26",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167137",
      "source": "custom",
      "poi_name": "Mountainside Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "10435 W McDowell Rd, Avondale, AZ 85392, USA",
      "poi_short_description": "Large, locally owned gym featuring classes and lots of equipment, plus friendly staff and childcare.",
      "poi_long_description": "People say this fitness center offers a wide variety of machines, a sauna, a cold plunge, and a steam room. They highlight the clean and well-maintained equipment, and the attentive and polite staff. They also like the childcare area with a bounce house and camera feeds on TVs.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167137/019d0216-98f4-7538-ad57-bb26a5e53b68.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0216-98f4-7538-ad57-bb26a5e53b68",
        "storage_key": "property/6767906449167137/019d0216-98f4-7538-ad57-bb26a5e53b68.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "https://mountainsidefitness.com/clubs/avondale/?utm_source=GMB&utm_medium=Local&utm_campaign=Avondale%20Club&utm_content=WebsiteLink",
      "poi_directions_map_url": "https://maps.google.com/?cid=14845768426956053507&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "mountainside-fitness",
      "poi_latitude": "33.4630251",
      "poi_longitude": "-112.2834988",
      "poi_miles_from_property": "3.6",
      "poi_walking_minutes": "1 hour 20 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 623-440-5911",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167137/019d0216-4fa2-70ce-add6-233c721bc076.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0216-4fa2-70ce-add6-233c721bc076",
        "storage_key": "property/6767906449167137/019d0216-4fa2-70ce-add6-233c721bc076.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ9zZvMEM_K4cRA9xsYrrDBs4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fitness_center"
    },
    {
      "id": "custom_95b23a4a-74aa-4f62-9661-e67b3a053a36",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167137",
      "source": "custom",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "7333 W Thomas Rd Ste 78, Phoenix, AZ 85033, USA",
      "poi_short_description": "Workout venue featuring treadmills, free weights and weight machines (some with massage areas) as well as showers.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167137/019d0216-176a-74be-b0bf-4eb198a35876.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0216-176a-74be-b0bf-4eb198a35876",
        "storage_key": "property/6767906449167137/019d0216-176a-74be-b0bf-4eb198a35876.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/phoenix-west-az?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=9175628663140348894&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "33.4791205",
      "poi_longitude": "-112.2180009",
      "poi_miles_from_property": "1.5",
      "poi_walking_minutes": "34 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 623-344-0600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167137/019d0216-4fa2-70ce-add6-233c721bc076.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0216-4fa2-70ce-add6-233c721bc076",
        "storage_key": "property/6767906449167137/019d0216-4fa2-70ce-add6-233c721bc076.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJEaoYCsbpQIYR3nNfkadhVn8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_60873347-c4fb-4157-85a8-9cb3d4b17a29",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167137",
      "source": "custom",
      "poi_name": "LA Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "7640 W Thomas Rd, Phoenix, AZ 85033, USA",
      "poi_short_description": "Basketball and racquetball courts at this health club with cardio equipment, strength machines and a pool.",
      "poi_long_description": "People say this gym offers a great place to play basketball, has a wide range of well-maintained equipment, and is very clean with friendly and helpful staff. They also highlight the great customer service, easy sign-up process, and motivating atmosphere.\n\nSome reviews mention the gym can be crowded.",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.lafitness.com/Pages/clubhome.aspx?clubid=50&utm_source=google&utm_medium=googlemaps&utm_campaign=maps",
      "poi_directions_map_url": "https://maps.google.com/?cid=6020149682764692760&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "la-fitness",
      "poi_latitude": "33.48153840000001",
      "poi_longitude": "-112.2232194",
      "poi_miles_from_property": "1.5",
      "poi_walking_minutes": "35 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 623-845-9920",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167137/019d0216-4fa2-70ce-add6-233c721bc076.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0216-4fa2-70ce-add6-233c721bc076",
        "storage_key": "property/6767906449167137/019d0216-4fa2-70ce-add6-233c721bc076.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJX7CbX0IVK4cRGL3ehz3ei1M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_9c336f8e-89b1-4ff6-a4c6-0129081acfd2",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167137",
      "source": "custom",
      "poi_name": "Spay Neuter Clinic: Glendale",
      "poi_type": "Health and Wellness",
      "poi_address": "5122 N 95th Ave Suite A-130, Glendale, AZ 85305, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.spayaz.com/locations/glendale-az/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9453633910399785105&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "spay-neuter-clinic-glendale",
      "poi_latitude": "33.5113541",
      "poi_longitude": "-112.2669496",
      "poi_miles_from_property": "5.6",
      "poi_walking_minutes": "2 hours 4 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 623-846-3979",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167137/019d0216-4fa2-70ce-add6-233c721bc076.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0216-4fa2-70ce-add6-233c721bc076",
        "storage_key": "property/6767906449167137/019d0216-4fa2-70ce-add6-233c721bc076.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJMzU_BkkVK4cRkVj3OfQNMoM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "veterinary_care"
    },
    {
      "id": "custom_ded19b8c-dede-4295-a866-158a7114e2e2",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167137",
      "source": "custom",
      "poi_name": "Banner Estrella Medical Center | Phoenix, AZ | Thomas Rd.",
      "poi_type": "Health and Wellness",
      "poi_address": "9201 W Thomas Rd, Phoenix, AZ 85037, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167137/019d0216-2dc4-71cd-b97a-03f77c4d23eb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0216-2dc4-71cd-b97a-03f77c4d23eb",
        "storage_key": "property/6767906449167137/019d0216-2dc4-71cd-b97a-03f77c4d23eb.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "https://www.bannerhealth.com/locations/phoenix/banner-estrella-medical-center?y_source=1_MTE5MDczNjUtNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=11847918637679302131&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "banner-estrella-medical-center--phoenix-az--thomas-rd",
      "poi_latitude": "33.4783538",
      "poi_longitude": "-112.257931",
      "poi_miles_from_property": "3",
      "poi_walking_minutes": "1 hour 6 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 623-327-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167137/019d0216-55cb-715e-8217-5b5b7addaca9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0216-55cb-715e-8217-5b5b7addaca9",
        "storage_key": "property/6767906449167137/019d0216-55cb-715e-8217-5b5b7addaca9.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJ45ieeOs_K4cR89WaXjpDbKQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_center"
    },
    {
      "id": "custom_309e63f0-bcf0-47b6-bbc0-83b31b21162c",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167137",
      "source": "custom",
      "poi_name": "Dignity Health, St. Joseph's Westgate Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "7300 N 99th Ave, Glendale, AZ 85305, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167137/019d0216-9ba0-70d5-a296-0e65a74f4f1a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0216-9ba0-70d5-a296-0e65a74f4f1a",
        "storage_key": "property/6767906449167137/019d0216-9ba0-70d5-a296-0e65a74f4f1a.webp",
        "width": 720,
        "height": 405
      },
      "poi_business_url": "https://locations.dignityhealth.org/st-joseph's-westgate-medical-center?utm_source=LocalSearch&utm_medium=Facility&utm_campaign=Arizona&utm_term=St.Joseph'sWestgateMedicalCenter",
      "poi_directions_map_url": "https://maps.google.com/?cid=11012381286240912858&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "dignity-health-st-josephs-westgate-medical-center",
      "poi_latitude": "33.5419739",
      "poi_longitude": "-112.27471",
      "poi_miles_from_property": "8",
      "poi_walking_minutes": "2 hours 57 mins",
      "poi_biking_minutes": "50 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 602-406-0000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167137/019d0216-55cb-715e-8217-5b5b7addaca9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0216-55cb-715e-8217-5b5b7addaca9",
        "storage_key": "property/6767906449167137/019d0216-55cb-715e-8217-5b5b7addaca9.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJ2w2qKrBBK4cR2oWMCW_W05g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_1e51c44d-d919-423e-b74d-23d4e7243e9f",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167137",
      "source": "custom",
      "poi_name": "Friendship Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "12325 W McDowell Rd, Avondale, AZ 85323, USA",
      "poi_short_description": "This sports complex offers 10 multi-use fields, 2 little league fields & 1 softball diamond.",
      "poi_long_description": "People say this park offers a variety of fun features, including playgrounds, sports fields, a fishing pond, and a dog park. They highlight the park is clean, well-maintained, and family-friendly, with plenty of parking and restrooms. They also like the friendly atmosphere and the presence of park rangers.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167137/019d0216-26ec-724e-bd5f-fc7f54c2a047.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0216-26ec-724e-bd5f-fc7f54c2a047",
        "storage_key": "property/6767906449167137/019d0216-26ec-724e-bd5f-fc7f54c2a047.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.avondaleaz.gov/government/departments/parks-recreation/parks",
      "poi_directions_map_url": "https://maps.google.com/?cid=17309830429229523955&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "friendship-park",
      "poi_latitude": "33.4604627",
      "poi_longitude": "-112.3226161",
      "poi_miles_from_property": "9.9",
      "poi_walking_minutes": "3 hours 36 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 623-333-2400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167137/019d0216-51ae-727c-b081-7484702f73b9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0216-51ae-727c-b081-7484702f73b9",
        "storage_key": "property/6767906449167137/019d0216-51ae-727c-b081-7484702f73b9.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJt_rvMEg_K4cR8yN5YBDfOPA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_a878250f-be36-4b5b-9856-ad0de1a45a16",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167137",
      "source": "custom",
      "poi_name": "Glendale Heroes Regional Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "83rd Avenue and, Bethany Home Rd, Glendale, AZ 85303, USA",
      "poi_short_description": "A city park with playgrounds, water play area, skate & BMX facility, picnicking, basketball & more.",
      "poi_long_description": "Visitors say this park offers a splash pad, skate park, playground, and a pond for fishing. They also highlight the clean facilities, peaceful atmosphere, and family-friendly environment.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167137/019d0216-9d19-701b-976d-32f56c4a4cea.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0216-9d19-701b-976d-32f56c4a4cea",
        "storage_key": "property/6767906449167137/019d0216-9d19-701b-976d-32f56c4a4cea.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.glendaleaz.com/parksandrecreation/GlendaleHeroesPark.cfm",
      "poi_directions_map_url": "https://maps.google.com/?cid=15557125583860822947&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "glendale-heroes-regional-park",
      "poi_latitude": "33.5263956",
      "poi_longitude": "-112.2364476",
      "poi_miles_from_property": "5.1",
      "poi_walking_minutes": "1 hour 53 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 623-930-2820",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167137/019d0216-51ae-727c-b081-7484702f73b9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0216-51ae-727c-b081-7484702f73b9",
        "storage_key": "property/6767906449167137/019d0216-51ae-727c-b081-7484702f73b9.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJjd7tH5xqK4cRo3MqGEsD5tc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_3379f972-d4fe-4ba8-889b-275f4dd8a2a6",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167137",
      "source": "custom",
      "poi_name": "Grand Canyon University Championship Golf Course",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "5902 W Indian School Rd, Phoenix, AZ 85033, USA",
      "poi_short_description": "Public 18-hole golf course & a modern clubhouse with a restaurant, bar, pro shop & events space.",
      "poi_long_description": "Golfers say this golf course offers challenging greens, numerous bunkers with great sand, and well-maintained fairways. They also highlight the friendly and polite staff, the efficient pace of play, and the well-stocked beverage cart.\n\nSome reviews mention the price can be high.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167137/019d0216-9f7e-7309-b713-55673d50b42b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0216-9f7e-7309-b713-55673d50b42b",
        "storage_key": "property/6767906449167137/019d0216-9f7e-7309-b713-55673d50b42b.webp",
        "width": 1024,
        "height": 576
      },
      "poi_business_url": "http://gcugolf.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5740069318367373165&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "grand-canyon-university-championship-golf-course",
      "poi_latitude": "33.4959033",
      "poi_longitude": "-112.1877902",
      "poi_miles_from_property": "4.3",
      "poi_walking_minutes": "1 hour 37 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 623-846-4022",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167137/019d0216-adf3-7668-b4c0-b551c6961fc4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0216-adf3-7668-b4c0-b551c6961fc4",
        "storage_key": "property/6767906449167137/019d0216-adf3-7668-b4c0-b551c6961fc4.webp",
        "width": 132,
        "height": 192
      },
      "poi_google_place_id": "ChIJw5NoJygVK4cRbednA6LSqE8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "golf_course"
    },
    {
      "id": "custom_ab922b66-0c35-47f8-ad1b-68ff3218e674",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167137",
      "source": "custom",
      "poi_name": "El Oso Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "FQQJ+637, 3451 N 75th Ave, Phoenix, AZ 85033, USA",
      "poi_short_description": "40-acre neighborhood park featuring play structures, exercise paths & plenty of sports facilities.",
      "poi_long_description": "40-acre neighborhood park featuring play structures, exercise paths & plenty of sports facilities.",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://phoenix.gov/parks/parks/alphabetical/e-parks",
      "poi_directions_map_url": "https://maps.google.com/?cid=3991665163825136944&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "el-oso-park",
      "poi_latitude": "33.4876847",
      "poi_longitude": "-112.2183578",
      "poi_miles_from_property": "2.1",
      "poi_walking_minutes": "47 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 602-262-6575",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167137/019d0216-51ae-727c-b081-7484702f73b9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0216-51ae-727c-b081-7484702f73b9",
        "storage_key": "property/6767906449167137/019d0216-51ae-727c-b081-7484702f73b9.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJgfE6ekYVK4cRMEUZWFE-ZTc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_72a359f5-a289-42a2-9d71-13888f32f35c",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167137",
      "source": "custom",
      "poi_name": "Cielito Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "3402 West Campbell Ave, Phoenix, AZ 85017, USA",
      "poi_short_description": "Accessible park with lit basketball, tennis & softball courts, a pool, playground & picnic area,",
      "poi_long_description": "Accessible park with lit basketball, tennis & softball courts, a pool, playground & picnic area,",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.phoenix.gov/parks/parks/alphabetical/c-parks",
      "poi_directions_map_url": "https://maps.google.com/?cid=8988645062362245492&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "cielito-park",
      "poi_latitude": "33.5038779",
      "poi_longitude": "-112.1313753",
      "poi_miles_from_property": "7.9",
      "poi_walking_minutes": "2 hours 56 mins",
      "poi_biking_minutes": "46 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 602-262-6575",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167137/019d0216-51ae-727c-b081-7484702f73b9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0216-51ae-727c-b081-7484702f73b9",
        "storage_key": "property/6767906449167137/019d0216-51ae-727c-b081-7484702f73b9.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJmSeENFsTK4cRdKkrcg8Vvnw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_1639871e-79d4-4641-b246-8b260e81d803",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167137",
      "source": "custom",
      "poi_name": "Glendale Regional Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "6801 N Glen Harbor Blvd, Glendale, AZ 85307, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167137/019d0216-9f7f-7335-8b27-c00c0ba27f70.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0216-9f7f-7335-8b27-c00c0ba27f70",
        "storage_key": "property/6767906449167137/019d0216-9f7f-7335-8b27-c00c0ba27f70.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.glendaleaz.com/live/amenities/airport",
      "poi_directions_map_url": "https://maps.google.com/?cid=6794599642740604503&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "glendale-regional-airport",
      "poi_latitude": "33.5296849",
      "poi_longitude": "-112.2972206",
      "poi_miles_from_property": "9.3",
      "poi_walking_minutes": "3 hours 24 mins",
      "poi_biking_minutes": "59 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 623-930-2188",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167137/019d0216-5577-7288-81d9-a4b48b842474.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0216-5577-7288-81d9-a4b48b842474",
        "storage_key": "property/6767906449167137/019d0216-5577-7288-81d9-a4b48b842474.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJA0ED0OVAK4cRV76MMGBES14",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "custom_e31ee214-1c8c-4c83-a909-b46e7120c1da",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167137",
      "source": "custom",
      "poi_name": "Glendale Airport Hangars",
      "poi_type": "Transportation & Transit",
      "poi_address": "6635 N Glen Harbor Blvd, Glendale, AZ 85307, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.glendalehangars.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2167914040134275342&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "glendale-airport-hangars",
      "poi_latitude": "33.5258118",
      "poi_longitude": "-112.2994901",
      "poi_miles_from_property": "9.6",
      "poi_walking_minutes": "3 hours 30 mins",
      "poi_biking_minutes": "1 hour 1 min",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 623-476-4765",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167137/019d0216-5577-7288-81d9-a4b48b842474.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0216-5577-7288-81d9-a4b48b842474",
        "storage_key": "property/6767906449167137/019d0216-5577-7288-81d9-a4b48b842474.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJLYoc0OVAK4cRDhHJWVX6FR4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "custom_86093e9d-90d5-4552-8a56-895218ce88c2",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167137",
      "source": "custom",
      "poi_name": "Pepsi Gatorade DC",
      "poi_type": "Major Employers & Offices",
      "poi_address": "860 South 75th Avenue, Tolleson, AZ 85353, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=17242266875067633265&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "pepsi-gatorade-dc",
      "poi_latitude": "33.4395584",
      "poi_longitude": "-112.2228159",
      "poi_miles_from_property": "2.3",
      "poi_walking_minutes": "51 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167137/019d0216-4fa2-70ce-add6-233c721bc076.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0216-4fa2-70ce-add6-233c721bc076",
        "storage_key": "property/6767906449167137/019d0216-4fa2-70ce-add6-233c721bc076.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJJyCrtVcVK4cRcQ7kkl7WSO8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_33f1c5ae-a730-408c-a61b-5a5eef77b921",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167137",
      "source": "custom",
      "poi_name": "JBS Beef Plant TollesonAZ - Business Access",
      "poi_type": "Major Employers & Offices",
      "poi_address": "8990 W Buckeye Rd, Tolleson, AZ 85353, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=5742067192014743564&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "jbs-beef-plant-tollesonaz---business-access",
      "poi_latitude": "33.4359509",
      "poi_longitude": "-112.2525141",
      "poi_miles_from_property": "3.8",
      "poi_walking_minutes": "1 hour 24 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 623-476-4110",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167137/019d0216-4fa2-70ce-add6-233c721bc076.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0216-4fa2-70ce-add6-233c721bc076",
        "storage_key": "property/6767906449167137/019d0216-4fa2-70ce-add6-233c721bc076.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJs5Jq-ao_K4cRDKh2OLDrr08",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_73a01293-3dff-4846-abc0-1508cd54a784",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167137",
      "source": "custom",
      "poi_name": "City of Avondale",
      "poi_type": "Major Employers & Offices",
      "poi_address": "11465 West, 11465 W Civic Ctr Dr, Avondale, AZ 85323, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167137/019d0216-a289-717f-a16a-cd4106294ba6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0216-a289-717f-a16a-cd4106294ba6",
        "storage_key": "property/6767906449167137/019d0216-a289-717f-a16a-cd4106294ba6.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.avondaleaz.gov/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13622991710836474318&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "city-of-avondale",
      "poi_latitude": "33.4444488",
      "poi_longitude": "-112.3044385",
      "poi_miles_from_property": "6.2",
      "poi_walking_minutes": "2 hours 16 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 623-333-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167137/019d0216-55e0-775a-86d5-ea92e6a5b1c7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0216-55e0-775a-86d5-ea92e6a5b1c7",
        "storage_key": "property/6767906449167137/019d0216-55e0-775a-86d5-ea92e6a5b1c7.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJq6rqDB4_K4cRzsF_hsiWDr0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_hall"
    },
    {
      "id": "custom_1bc02648-6887-4952-856f-f36fdaacab53",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167137",
      "source": "custom",
      "poi_name": "Coreslab Structures Inc",
      "poi_type": "Major Employers & Offices",
      "poi_address": "5026 S 43rd Ave, Phoenix, AZ 85041, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167137/019d0216-a3b5-7420-bb3d-6a2ebe0d33ec.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0216-a3b5-7420-bb3d-6a2ebe0d33ec",
        "storage_key": "property/6767906449167137/019d0216-a3b5-7420-bb3d-6a2ebe0d33ec.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.coreslab.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3509577761857353283&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "coreslab-structures-inc",
      "poi_latitude": "33.4006198",
      "poi_longitude": "-112.1517079",
      "poi_miles_from_property": "8.9",
      "poi_walking_minutes": "3 hours 15 mins",
      "poi_biking_minutes": "47 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 602-237-3875",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167137/019d0216-4fa2-70ce-add6-233c721bc076.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0216-4fa2-70ce-add6-233c721bc076",
        "storage_key": "property/6767906449167137/019d0216-4fa2-70ce-add6-233c721bc076.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJqXh7gcUWK4cRQzYeP2GGtDA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_e034bf32-bc05-413e-880b-0addb5c42fc5",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167137",
      "source": "custom",
      "poi_name": "Amarr Entrematic",
      "poi_type": "Major Employers & Offices",
      "poi_address": "6120 W Buckeye Rd, Phoenix, AZ 85043, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167137/019d0216-a5fb-7565-aa0b-09ea20058cc5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0216-a5fb-7565-aa0b-09ea20058cc5",
        "storage_key": "property/6767906449167137/019d0216-a5fb-7565-aa0b-09ea20058cc5.webp",
        "width": 1080,
        "height": 810
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=864760585476463460&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "amarr-entrematic",
      "poi_latitude": "33.4380735",
      "poi_longitude": "-112.1916194",
      "poi_miles_from_property": "4.1",
      "poi_walking_minutes": "1 hour 30 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 602-271-9504",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167137/019d0216-4fa2-70ce-add6-233c721bc076.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0216-4fa2-70ce-add6-233c721bc076",
        "storage_key": "property/6767906449167137/019d0216-4fa2-70ce-add6-233c721bc076.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJD-ZVaqARK4cRZFsVuSs_AAw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    }
  ],
  "office_hours": [
    {
      "id": "ec_19aa88d17dfdd5e2684a733d",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167137",
      "day": "MON",
      "open_time": "09:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_f1e21a4754d1afdfa80d73de",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167137",
      "day": "TUE",
      "open_time": "09:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_04a196c47e8a765452c35d74",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167137",
      "day": "THU",
      "open_time": "09:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_fed5eb655bef2c7b20079890",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167137",
      "day": "FRI",
      "open_time": "09:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_025d8403ed8672a04b413767",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167137",
      "day": "WED",
      "open_time": "09:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_94ed207cdbd4b381bda24752",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167137",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "17:00"
    }
  ],
  "reviews": [
    {
      "id": "ec_e3e4cbba8b2dff2d11d31372",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167137",
      "rating": "5",
      "name": "false",
      "text": "I lived here for a year... This place is perfect walking distance for everything.\n\nEveryone seemed very nice and the office staff ever very patient and nice... (except for one staff member that was dismissed shortly after their rude behavior)\n\nWhen they make mistakes and you show proof they go the extra mile to help you out. I had a electric bill issue that was the fault of the staff. It took 2 months to resolve but never need to pay a late fee for it.\n\nMaintenance will always be on time when they are scheduled or next day (even on weekends if you are free!) never had to wait long for help.\n\nThe ONLY issue I had noise wise was only 2 times when someone was playing bass music too loud and children running around above us (but that can be easily ignored with headphones).. Like I said friendly community... neighbors are friendly!\n\nI highly recommend this apartment to anyone that going to live in the area.",
      "date": "false",
      "title": "Professional, Quick and Nice"
    },
    {
      "id": "ec_cacff25de507a4f082ad12ed",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167137",
      "rating": "4",
      "name": "false",
      "text": "I've been living here for about 9 months, I have no complaints so far. I've read other reviews saying it is loud and noisy, but i have not had any bad experiences with that type of situation. That being said, I do live on the outside of the complex so it might be a lot different if you live in the inner parts but I have no idea. Had a cockroach issue when I first moved in, and they took care of it very quickly! That, I was very impressed with. Every Monday they have a pest control guy that goes and sprays, so any tenant who needs the spraying just needs to schedule prior to that Monday.",
      "date": "false",
      "title": "This place is solid."
    },
    {
      "id": "ec_467f26cffc00b541492d9a87",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167137",
      "rating": "4",
      "name": "false",
      "text": "Beautiful apartments with great floor plans. Very clean buildings and good security in the property. If neighbors are good this property is a great place to live.",
      "date": "false",
      "title": "Good Value"
    },
    {
      "id": "ec_f92eb6b0791e70d66212e20f",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167137",
      "rating": "4",
      "name": "false",
      "text": "Bolero apartments are very nice. The community is very well kept and the  staff is very friendly and easy to work with. The maitnence is awesome and will fix your requests really fast. I wish I could stay but the only bad thing is their rent has increased to where it no longer is in my budget. Being a college student living on your own this is a great and safe community.",
      "date": "false",
      "title": "Bolero Apartments"
    },
    {
      "id": "ec_8e7e48155019500768025c19",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167137",
      "rating": "5",
      "name": "false",
      "text": "I have nothing but great things to say about Bolero Apartments. They are on top of everything. When I send in a Work order is is responded to the same day, when i had an issue with my water they were beyond fair. Its a very clean, safe and quiet neighborhood.",
      "date": "false",
      "title": "Life at Bolero"
    },
    {
      "id": "ec_dc7c335cdc55028e01d7fcae",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167137",
      "rating": "5",
      "name": "false",
      "text": "I really love these apartments. I have 9 months living here and I have never had any issues with my parking lot, roaches, or any tipical issues you run by at any other apartments. The only recent issues have been running toilets but the office has been very responsive when it comes to resolving that issue. The pools are always clean and in good condition. I like how about every month they power wash the apartments to have them looking clean. The apartments are located at a great location with the freeway right down the street. There is also many restaurants and stores right around the corner. Bolero apartments are at a perfect spot with everything you need nearby.  They are also very convinient because they have laundry and dryer and you dont have to leave your apartments to get laundary done. They have many different floor plans to choose from and also three pools to choose from to go enjoy a great afternoon. There gym facility is also great its always clean and smelling fresh. I really enjoy living here and Iam looking forward to renewing my lease once my year is up. I really recomend Bolero Apartments. :)",
      "date": "false",
      "title": "Bolero apartment review"
    },
    {
      "id": "ec_aa88f6c62e583d6cc1c1e3b1",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167137",
      "rating": "4",
      "name": "false",
      "text": "Parking lot and neighbors were always loud, even at night. Neighbors downstairs would have parties till 4 am. Walls are thin and we could hear people yelling in other units. Parking lot is too small for how many residents the complex carries. My roommates and myself had three cars and only one designated parking spot that other residents would sometimes park in. If we got home late, we would have to drive through the entire parking lot, finding nothing. There were many times I parked in a handicap spot (illegally) because it was the only thing left. As a young female, I did not feel safe parking off the property and walking on late at night, especially so close to Maryvale. The staff in the leasing office gave us attitude at times but I think they meant well. It was a clean apartment and the inside was nice. It was also convenient to have three pools available. The gate keys did not always work to get in however and one time, one of the pools smelled of urine.",
      "date": "false",
      "title": "Decent"
    }
  ],
  "virtual_tours": [
    {
      "id": "custom_6eb26ba8-dc32-4c44-a71c-fb0215ccdc9a",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167137",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167137/019d0217-3c40-7335-b6c8-273cc6e5d5af.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Spacious living area with a connected kitchen, featuring large windows and a ceiling fan.",
        "public_id": "019d0217-3c40-7335-b6c8-273cc6e5d5af",
        "storage_key": "property/6767906449167137/019d0217-3c40-7335-b6c8-273cc6e5d5af.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Aria S1 | Studio x 1 Bathroom | 483 Sq Ft",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=pRuSn1ZtXtT"
    },
    {
      "id": "custom_91c0f252-3d03-48e0-8f7f-8b69461f3f82",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167137",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167137/019d0217-3bbe-70df-886e-20cb36970064.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Kitchen with light wood cabinets, granite countertops, and stainless steel appliances.",
        "public_id": "019d0217-3bbe-70df-886e-20cb36970064",
        "storage_key": "property/6767906449167137/019d0217-3bbe-70df-886e-20cb36970064.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Bolero | Brio | 1BR, 1BA - 721SF",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=XRihJDvvifZ"
    },
    {
      "id": "custom_ca71df67-ad75-4aed-a282-f61b29c14210",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167137",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167137/019d0217-3bb3-711f-83c4-dfbbe9b0f1d5.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Living room and kitchen area of an apartment",
        "public_id": "019d0217-3bb3-711f-83c4-dfbbe9b0f1d5",
        "storage_key": "property/6767906449167137/019d0217-3bb3-711f-83c4-dfbbe9b0f1d5.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Bolero | Aria C2 | 2 BR, 2 BA - 799 SF",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=1NLdNZih5UG"
    },
    {
      "id": "custom_e1d44754-c6c0-421e-a34e-f0ca494d5255",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167137",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167137/019d0217-3c08-7075-b1ce-ac93b96df0cb.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Living room and dining area with sofas, coffee table, dining table, and kitchen counter.",
        "public_id": "019d0217-3c08-7075-b1ce-ac93b96df0cb",
        "storage_key": "property/6767906449167137/019d0217-3c08-7075-b1ce-ac93b96df0cb.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Bolero | Brio C4 | 2BR, 2BA - 969 SF",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=BfjnX4XFcTk"
    }
  ],
  "faqs": [
    {
      "id": "custom_cace2b3c-269b-43cc-831e-cf99084967a9",
      "question": "What apartment layouts are available at Bolero?",
      "answer": "Bolero offers studio, one-, two-, and three-bedroom apartments.",
      "category": "Floor Plans",
      "source": "custom"
    },
    {
      "id": "custom_68b0b083-a33e-4fd6-8c03-cb882ab4601b",
      "question": "Are laundry appliances included in the apartment homes?",
      "answer": "Yes, every apartment features a convenient in-home washer and dryer.",
      "category": "Floor Plans",
      "source": "custom"
    },
    {
      "id": "custom_7a46e80b-3428-49ef-9370-50f468f21d40",
      "question": "What utility options or smart home features are built-in?",
      "answer": "Homes feature high-speed internet capability, ceiling fans, and air conditioning and heating.",
      "category": "Floor Plans",
      "source": "custom"
    },
    {
      "id": "custom_3ee99aad-5ff3-407c-91bf-6bb960012f1e",
      "question": "How many swimming pools are available at Bolero?",
      "answer": "Residents have access to three sparkling swimming pools, along with soothing spas.",
      "category": "Amenities",
      "source": "custom"
    },
    {
      "id": "custom_597f3d83-fe63-450e-b672-522451982004",
      "question": "Are there on-site fitness facilities at Bolero?",
      "answer": "Yes. Bolero has two fitness centers.",
      "category": "Amenities",
      "source": "custom"
    },
    {
      "id": "custom_0a15a225-7078-4e9c-befb-a926e2835ebd",
      "question": "Is renter's insurance required?",
      "answer": "Yes, we require all residents to maintain an active renter's insurance policy for the duration of their lease.",
      "category": "Applying",
      "source": "custom"
    },
    {
      "id": "custom_52977fe1-17e2-4fea-9be7-9e12ad2a9d19",
      "question": "What documents do I need to bring to apply for an apartment?",
      "answer": "Applicants typically need a valid photo ID and proof of income, such as recent pay stubs or an offer letter. Some communities may also request proof of prior residency or additional financial documentation — contact the leasing office to confirm exact requirements before you apply.",
      "category": "Applying",
      "source": "custom"
    }
  ],
  "fees": [],
  "pet_policies": [],
  "lead_collectors": [
    {
      "lead_collector_id": "019e73bc-22d8-7249-aabc-6e50cd753196",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "Bolero Website",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167137"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167137",
      "source": "generator",
      "page_item_url": "dog-friendly-apartments-maryvale-village-bolero",
      "search_query": "dog friendly apartments in Maryvale Village",
      "category": "Amenity",
      "h1_title": "Dog Friendly Apartments in Maryvale Village",
      "h2_subtitle": "Discover dog friendly apartments in the vibrant Maryvale Village. Bolero offers pet-friendly living with exciting amenities for you and your furry friend.",
      "page_copy": "Looking for dog friendly apartments in Maryvale Village? Bolero offers the perfect community for pet owners seeking comfort and convenience in Phoenix. Located within the vibrant neighborhood of Maryvale Village, our apartments provide a welcoming environment for both you and your four-legged companion.\n\nAt Bolero, you'll enjoy an array of amenities designed to enhance your living experience, including free Wi-Fi hot spots and an easy online rent payment system. Keep cool with efficient air conditioning and take advantage of 24 hour access to community facilities. Our beautifully maintained cabanas offer a relaxing spot for leisurely afternoons with your pet. Come see why Bolero is the ideal choice for dog lovers in Phoenix.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Dog Friendly Apartments in Maryvale Village",
      "seo_description": "Discover Bolero, where dog friendly apartments in Maryvale Village come with great amenities and pet-friendly living.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167137",
      "source": "generator",
      "page_item_url": "apartments-in-unit-laundry-phoenix-az-bolero",
      "search_query": "apartments with in-unit laundry in Phoenix AZ",
      "category": "Amenity",
      "h1_title": "Apartments with In-Unit Laundry in Phoenix, AZ",
      "h2_subtitle": "Experience convenience in Phoenix with apartments featuring in-unit laundry. Bolero offers modern living tailored to your lifestyle needs.",
      "page_copy": "Discover the ease of living in apartments with in-unit laundry in Phoenix, AZ, at Bolero. Our vibrant community in Maryvale Village combines comfort with modern conveniences, ensuring you enjoy a stress-free lifestyle. With the inclusion of in-unit laundry facilities, you’ll appreciate the extra time saved and the added privacy.\n\nBolero's commitment to offering top-notch amenities doesn’t stop at in-unit laundry. Our residents benefit from excellent services, such as free Wi-Fi hot spots, easy online rent payment, and round-the-clock access to facilities. Situated in the lively neighborhood of Maryvale Village, Bolero is designed to cater to your needs, making everyday living more convenient and enjoyable.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Phoenix Apartments with In-Unit Laundry",
      "seo_description": "Discover Bolero for apartments with in-unit laundry in Phoenix, AZ. Enjoy convenience and modern amenities in Maryvale Village.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167137",
      "source": "generator",
      "page_item_url": "luxury-apartments-pools-maricopa-county-bolero",
      "search_query": "luxury apartments with pools in Maricopa County",
      "category": "Amenity",
      "h1_title": "Luxury Apartments with Pools in Maricopa County",
      "h2_subtitle": "Explore luxury apartments with pools in Maricopa County. Bolero offers upscale living with a range of premium amenities.",
      "page_copy": "Dive into elegance at Bolero, where luxury apartments with pools in Maricopa County redefine upscale living. Situated in the vibrant Maryvale Village of Phoenix, these apartments offer residents a refined lifestyle complemented by a host of premium amenities.\n\nAt Bolero, enjoy our meticulously designed poolside cabanas, perfect for relaxation under the Arizona sun. Besides the luxurious pools, our community features free Wi-Fi hot spots, convenient online rent payments, and exclusive 24-hour access to various facilities. Come and experience the sophisticated blend of comfort and convenience Bolero provides in Maricopa County.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Luxury Apartments with Pools in Maricopa",
      "seo_description": "Discover Bolero's luxury apartments with pools in Maricopa County, offering premium amenities in vibrant Maryvale Village.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167137",
      "source": "generator",
      "page_item_url": "energy-efficient-ceiling-fan-apartments-maryvale",
      "search_query": "energy efficient ceiling fan apartments in Maryvale Village",
      "category": "Amenity",
      "h1_title": "Energy Efficient Ceiling Fan Apartments in Maryvale",
      "h2_subtitle": "Find apartments with energy efficient ceiling fans in Maryvale Village. Bolero offers sustainable living with modern amenities.",
      "page_copy": "Live sustainably at Bolero, featuring energy efficient ceiling fan apartments in Maryvale Village. Located in the heart of Phoenix, our community prioritizes eco-friendly living without compromising on comfort. Our energy efficient ceiling fans help you maintain a comfortable environment while reducing energy costs.\n\nBolero sets the standard for modern apartment living with amenities that enhance your lifestyle. Enjoy free Wi-Fi hot spots, effortless online rent payment, and access to community facilities round-the-clock. Nestled in the vibrant Maryvale Village, Bolero offers a unique blend of sustainability and convenience, making it the ideal choice for eco-conscious residents.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Energy Efficient Ceiling Fan Apartments",
      "seo_description": "Discover energy efficient ceiling fan apartments in Maryvale Village at Bolero, offering sustainable living paired with modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167137",
      "source": "generator",
      "page_item_url": "gated-community-apartments-phoenix-az-bolero",
      "search_query": "gated community apartments in Phoenix AZ",
      "category": "Amenity",
      "h1_title": "Gated Community Apartments in Phoenix, AZ",
      "h2_subtitle": "Discover gated community apartments in Phoenix, AZ. Bolero provides a secure, tranquil living experience with top amenities.",
      "page_copy": "Welcome to Bolero, where gated community living in Phoenix, AZ offers peace of mind and comfort. Nestled in the serene Maryvale Village neighborhood, our gated community apartments are designed to provide a secure environment that enhances your lifestyle.\n\nAt Bolero, enjoy a range of premium amenities, including free Wi-Fi hot spots and simple online rent payment options, all within a secure gated setting. With 24-hour access to our facilities, such as our inviting cabanas, you’ll find everything you need to relax and unwind. Experience the perfect blend of security and convenience at Bolero in Phoenix, Arizona.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Gated Community Apartments in Phoenix, AZ",
      "seo_description": "Explore Bolero's gated community apartments in Phoenix, AZ, offering security and modern amenities in Maryvale Village.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167137",
      "source": "generator",
      "page_item_url": "one-bedroom-apartments-maryvale-village-bolero",
      "search_query": "one bedroom apartments in Maryvale Village",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments in Maryvale Village",
      "h2_subtitle": "Discover one bedroom apartments in Maryvale Village. Bolero offers modern living with a range of amenities in a prime location.",
      "page_copy": "Experience modern living in the heart of Phoenix at Bolero, where our one bedroom apartments in Maryvale Village offer the perfect balance of comfort and convenience. Designed with contemporary features, these apartments provide an ideal retreat within this vibrant community.\n\nResidents of Bolero enjoy access to a host of amenities including air conditioning, free Wi-Fi hot spots, and easy online rent payments. Whether you're relaxing by our poolside cabanas or taking advantage of our facilities available 24 hours a day, Bolero in Maryvale Village is the perfect place to call home.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "One Bedroom Apartments in Maryvale Village",
      "seo_description": "Find modern one bedroom apartments at Bolero in Maryvale Village, Phoenix, featuring premium amenities in a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167137",
      "source": "generator",
      "page_item_url": "two-bedroom-apartments-phoenix-az-bolero",
      "search_query": "two bedroom apartments Phoenix AZ",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Apartments in Phoenix, AZ",
      "h2_subtitle": "Explore two bedroom apartments in Phoenix, AZ at Bolero. Our community offers spacious living with top-notch amenities in Maryvale Village.",
      "page_copy": "Welcome to Bolero in Phoenix, AZ, where our two bedroom apartments offer spacious and comfortable living. Located in the bustling Maryvale Village, these apartments are perfect for those seeking a vibrant yet homely environment.\n\nBolero provides residents with a variety of amenities including air conditioning, free Wi-Fi hot spots, and the convenience of online rent payment. With our secure, 24-hour access community facilities and relaxing cabanas, you have everything you need to enjoy stylish living in Phoenix. Discover the perfect blend of convenience and comfort with our two bedroom apartments today.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two Bedroom Apartments in Phoenix, AZ",
      "seo_description": "Discover spacious two bedroom apartments at Bolero in Phoenix, AZ, with top amenities in vibrant Maryvale Village.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167137",
      "source": "generator",
      "page_item_url": "three-bedroom-apartments-maricopa-county-bolero",
      "search_query": "three bedroom apartments in Maricopa County",
      "category": "Floorplan",
      "h1_title": "Three Bedroom Apartments in Maricopa County",
      "h2_subtitle": "Discover spacious three bedroom apartments in Maricopa County. Bolero offers comfort and modern amenities in a premier location.",
      "page_copy": "Bolero welcomes you to explore our three bedroom apartments located in Maricopa County. These spacious units provide an ideal living environment for families or individuals seeking extra room. Nestled in the vibrant Maryvale Village, our community combines a prime location with a warm and welcoming atmosphere.\n\nResidents enjoy Bolero’s extensive amenities, including air conditioners, free Wi-Fi hot spots, and easy online rent payment options. Our community also features 24-hour access to facilities, making it convenient to enjoy our serene cabanas and more. Experience the perfect mix of comfort and convenience in Maricopa County at Bolero.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Three Bedroom Apartments in Maricopa County",
      "seo_description": "Explore spacious three bedroom apartments at Bolero in Maricopa County, offering modern amenities and a welcoming community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "bobbi@repli360.com"
    },
    {
      "ID": "custom_pixel_id",
      "type": "STRING",
      "value": "1035508496598043"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "11308920196"
    },
    {
      "ID": "custom_text_us_url",
      "type": "STRING",
      "value": "https://popcard.rentcafe.com/TextUsWidget.aspx?dnis=6234325807"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-5CKL5BRL"
    },
    {
      "ID": "custom_rollout_phase",
      "type": "STRING",
      "value": "Phase 4"
    },
    {
      "ID": "custom_rentgrata_token",
      "type": "STRING",
      "value": "77470695-8540-4f4a-adeb-9f58a29fae70"
    },
    {
      "ID": "custom_vibesites_theme",
      "type": "STRING",
      "value": "Oasis"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_pricing_verbiage",
      "type": "STRING",
      "value": "<strong>Featuring all-in-pricing.</strong> One total price, no hidden fees - just full transparency. With everything clearly listed so you can budget with certainty. Customize by adding parking, animals, and more."
    },
    {
      "ID": "custom_rentcafe_chatbot",
      "type": "STRING",
      "value": "<script type=\"text/javascript\" src=\"//webchat.omni.cafe/conversations/d9dce6b3-8a60-4d48-951e-680efb03c3a2/app.js?property=d9dce6b3-8a60-4d48-951e-680efb03c3a2&propertyName=Bolero&channelUuid=c2490ab1-8dac-11ec-afb4-42010aa42b&buttonbgcolor=012345\" defer></script>"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "47594847664"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "turnkey"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6Ik9hWUNvQTc4QnhtU2Z2S2ZiQ3UxdEE9PSIsInZhbHVlIjoiVmdLZGg5QlJJeDg1bkFZQXRpR1FZUT09IiwibWFjIjoiZWM0MWQwNTgyMTk3OTI5ODExNGM4ZWJmMDM4NDczMzdjYzc1NTY0MjEyMjBiY2NhZThhMGNlYjQ1ZjUwNTFkNSJ9"
    }
  ],
  "custom_csm": "bobbi@repli360.com",
  "custom_pixel_id": "1035508496598043",
  "custom_repli_id": "11308920196",
  "custom_text_us_url": "https://popcard.rentcafe.com/TextUsWidget.aspx?dnis=6234325807",
  "custom_google_gtm_id": "GTM-5CKL5BRL",
  "custom_rollout_phase": "Phase 4",
  "custom_rentgrata_token": "77470695-8540-4f4a-adeb-9f58a29fae70",
  "custom_vibesites_theme": "Oasis",
  "custom_ads_subscription": "none",
  "custom_pricing_verbiage": "<strong>Featuring all-in-pricing.</strong> One total price, no hidden fees - just full transparency. With everything clearly listed so you can budget with certainty. Customize by adding parking, animals, and more.",
  "custom_rentcafe_chatbot": "<script type=\"text/javascript\" src=\"//webchat.omni.cafe/conversations/d9dce6b3-8a60-4d48-951e-680efb03c3a2/app.js?property=d9dce6b3-8a60-4d48-951e-680efb03c3a2&propertyName=Bolero&channelUuid=c2490ab1-8dac-11ec-afb4-42010aa42b&buttonbgcolor=012345\" defer></script>",
  "custom_seo_subscription": "none",
  "custom_hubspot_company_id": "47594847664",
  "custom_social_subscription": "none",
  "custom_website_subscription": "turnkey",
  "custom_apartmentsync_javascript_id": "eyJpdiI6Ik9hWUNvQTc4QnhtU2Z2S2ZiQ3UxdEE9PSIsInZhbHVlIjoiVmdLZGg5QlJJeDg1bkFZQXRpR1FZUT09IiwibWFjIjoiZWM0MWQwNTgyMTk3OTI5ODExNGM4ZWJmMDM4NDczMzdjYzc1NTY0MjEyMjBiY2NhZThhMGNlYjQ1ZjUwNTFkNSJ9",
  "custom_audioeye_site_id": "41f1382c-0912-48b9-aba9-0bff1395815a",
  "custom_audioeye_site_hash": "10c4438b4065d67c25fedf9ff86953d5"
};

export const generatedAt = '2026-10-29T20:20:40.205Z';
